/* GENERATED by tools/build_sk_bundle.py (SK-70) - do not edit this file.
   Edit the sources in assets/ (sk-core.js, sk-carousel.js, sk-sections-2.js, sk-chrome.js, sk-cart.js, sk-quick-add.js)
   and run: python tools/build_sk_bundle.py */

/* ===== sk-core.js ===== */
try {
/* SawaKart core (P1): window.SK API, <sk-reveal>, quick-add cart flow + Empire ATC banner opener,
   money formatter, cubic-bezier solver, reduced-motion + theme-editor helpers. Loaded with `defer`.
   (Comment-only edits here are also used to check that the GitHub sync reaches the theme.) */
(function () {
  'use strict';

  if (window.SK && window.SK.__core) return;

  var html = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function cfg() { return window.skTheme || {}; }

  function route(name, fallback) {
    var t = window.Theme && window.Theme.routes;
    var s = cfg().routes;
    return (t && t[name]) || (s && s[name]) || fallback;
  }

  function reducedMotion() {
    if (mq && mq.matches) return true;
    return !!(document.body && document.body.hasAttribute('data-reduce-animations'));
  }

  function inEditor() {
    return !!((window.Shopify && window.Shopify.designMode) || html.classList.contains('in-theme-editor'));
  }

  /* ---------- IntersectionObserver helper (shared observer per margin, fires once) ---------- */
  var observers = {};

  function observeOnce(el, marginPx, cb) {
    if (!el || typeof cb !== 'function') return function () {};
    if (!('IntersectionObserver' in window)) {
      cb(null);
      return function () {};
    }
    /* a number is px on every side; a string with units is a whole rootMargin, e.g. '0px 0px -8% 0px' */
    var margin;
    if (typeof marginPx === 'string' && /[%a-z]/i.test(marginPx)) {
      margin = marginPx.trim();
    } else {
      var m = parseFloat(marginPx);
      if (!isFinite(m)) m = 0;
      margin = m + 'px';
    }
    var key = margin;
    var rec = observers[key];
    if (!rec) {
      rec = { map: new Map() };
      rec.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          /* in view, or already scrolled past (mtstorelb: boundingClientRect.bottom < 0) */
          if (!entry.isIntersecting && entry.boundingClientRect.bottom >= 0) return;
          var list = rec.map.get(entry.target);
          rec.io.unobserve(entry.target);
          rec.map.delete(entry.target);
          if (list) list.forEach(function (fn) { fn(entry); });
        });
      }, { rootMargin: margin, threshold: 0 });
      observers[key] = rec;
    }
    var cbs = rec.map.get(el);
    if (!cbs) {
      cbs = [];
      rec.map.set(el, cbs);
      rec.io.observe(el);
    }
    cbs.push(cb);
    return function () {
      var list = rec.map.get(el);
      if (!list) return;
      var i = list.indexOf(cb);
      if (i > -1) list.splice(i, 1);
      if (!list.length) {
        rec.map.delete(el);
        rec.io.unobserve(el);
      }
    };
  }

  /* ---------- Money (D11) ---------- */
  function groupDigits(value, decimals, thousands, decimal) {
    var fixed = (Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents) {
    var n = typeof cents === 'string' ? parseFloat(cents.replace(/[^\d.-]/g, '')) : Number(cents);
    if (!isFinite(n)) n = 0;
    var value = n / 100;
    var c = cfg();
    // Always the store's Shopify money format, matching Liquid's `money` filter.
    var format = String(c.moneyFormat || '${{amount}}');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, type) {
      switch (type) {
        case 'amount_no_decimals': return groupDigits(value, 0, ',', '.');
        case 'amount_with_comma_separator': return groupDigits(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return groupDigits(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return groupDigits(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return groupDigits(value, 0, ' ', ',');
        case 'amount_with_space_separator': return groupDigits(value, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return groupDigits(value, 2, ' ', '.');
        default: return groupDigits(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Cubic-bezier solver (UnitBezier) ---------- */
  function bezier(x1, y1, x2, y2) {
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
    var cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    function sampleX(t) { return ((ax * t + bx) * t + cx) * t; }
    function sampleY(t) { return ((ay * t + by) * t + cy) * t; }
    function sampleDX(t) { return (3 * ax * t + 2 * bx) * t + cx; }
    function solveX(x) {
      var t = x, i, d, x2v;
      for (i = 0; i < 8; i++) {
        x2v = sampleX(t) - x;
        if (Math.abs(x2v) < 1e-7) return t;
        d = sampleDX(t);
        if (Math.abs(d) < 1e-6) break;
        t -= x2v / d;
      }
      var lo = 0, hi = 1;
      t = x;
      if (t < lo) return lo;
      if (t > hi) return hi;
      while (lo < hi) {
        x2v = sampleX(t);
        if (Math.abs(x2v - x) < 1e-7) return t;
        if (x > x2v) lo = t; else hi = t;
        t = (hi - lo) / 2 + lo;
        if (hi - lo < 1e-9) break;
      }
      return t;
    }
    return function (t) {
      if (t <= 0) return 0;
      if (t >= 1) return 1;
      return sampleY(solveX(t));
    };
  }

  /* ---------- Empire state-attribute animation protocol ---------- */
  function animateTo(el, to) {
    return new Promise(function (resolve) {
      var from = el.getAttribute('data-animation-state') || 'closed';
      if (from === to) {
        el.removeAttribute('data-animation');
        resolve();
        return;
      }
      requestAnimationFrame(function () {
        el.setAttribute('data-animation', from + '=>' + to);
        requestAnimationFrame(function () {
          var done = false;
          var timer;
          function finish() {
            if (done) return;
            done = true;
            clearTimeout(timer);
            el.removeEventListener('transitionend', onEnd);
            el.removeAttribute('data-animation');
            resolve();
          }
          function onEnd(e) { if (e.target === el) finish(); }
          el.addEventListener('transitionend', onEnd);
          timer = setTimeout(finish, 800);
          el.setAttribute('data-animation-state', to);
        });
      });
    });
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetWidth > 0 || n.offsetHeight > 0 || n.getClientRects().length > 0;
    });
  }

  /* ---------- ATC banner (Empire [data-atc-banner] template, restyled as the FE drawer by P5) ---------- */
  var openBanner = null;

  function setAnnouncementIndex(value) {
    var bar = document.querySelector('[data-announcement-bar]');
    if (bar) bar.style.setProperty('--index-announcement-bar', value);
  }

  function sizedImage(src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function setText(root, selector, text) {
    var n = root.querySelector(selector);
    if (n) n.textContent = text;
    return n;
  }

  function fillBanner(flyOut, item, cart, quantity) {
    var imgWrap = flyOut.querySelector('[data-atc-banner-product-image]');
    if (imgWrap && item.image) {
      var img = document.createElement('img');
      img.src = sizedImage(item.image, 200);
      img.alt = item.product_title || '';
      img.width = 200;
      img.height = 200;
      imgWrap.textContent = '';
      imgWrap.appendChild(img);
    }
    setText(flyOut, '[data-atc-banner-product-title]', item.product_title || item.title || '');

    var opts = item.variant_options || [];
    if (opts.length && opts[0] !== 'Title' && opts[0] !== 'Default Title') {
      setText(flyOut, '[data-atc-banner-product-options]', opts.join(', '));
    }
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      setText(flyOut, '[data-atc-banner-product-subscription-title]', item.selling_plan_allocation.selling_plan.name);
    }
    setText(flyOut, '[data-atc-banner-product-price-quantity]', quantity + ' × ');

    var line = null;
    (cart.items || []).forEach(function (it) {
      if (it.key === item.key || (!line && it.id === item.id)) line = line || it;
    });
    line = line || item;

    var priceValue = setText(flyOut, '[data-atc-banner-product-price-value]', formatMoney(line.original_price));
    var priceDiscounted = flyOut.querySelector('[data-atc-banner-product-price-discounted]');
    if (priceDiscounted) {
      if (line.final_price < line.original_price) {
        priceDiscounted.textContent = formatMoney(line.final_price);
        priceDiscounted.classList.remove('hidden');
        if (priceValue) priceValue.classList.add('original-price');
      } else {
        priceDiscounted.classList.add('hidden');
        if (priceValue) priceValue.classList.remove('original-price');
      }
    }

    var discounts = flyOut.querySelector('[data-atc-banner-product-discounts]');
    if (discounts) {
      var allocations = line.line_level_discount_allocations || [];
      if (allocations.length && discounts.firstElementChild) {
        var tpl = discounts.firstElementChild.cloneNode(true);
        discounts.textContent = '';
        allocations.forEach(function (a) {
          var li = tpl.cloneNode(true);
          setText(li, '.discount-title', (a.discount_application && a.discount_application.title) || '');
          setText(li, '.discount-amount', formatMoney(a.amount));
          discounts.appendChild(li);
        });
        discounts.classList.remove('hidden');
      } else {
        discounts.classList.add('hidden');
      }
    }

    var unit = flyOut.querySelector('[data-atc-banner-unit-price]');
    if (unit && line.unit_price_measurement) {
      var m = line.unit_price_measurement;
      var measure = m.reference_value === 1 ? m.reference_unit : m.reference_value + m.reference_unit;
      unit.innerHTML = unit.innerHTML
        .replace('** total_quantity **', String(m.quantity_value) + m.quantity_unit)
        .replace('** unit_price **', formatMoney(line.unit_price))
        .replace('** unit_measure **', measure);
      unit.classList.remove('hidden');
    }

    setText(flyOut, '[data-atc-banner-cart-subtotal]', formatMoney(cart.total_price));
    setText(flyOut, '[data-atc-banner-cart-button] span', String(cart.item_count));
  }

  function closeBanner() {
    var state = openBanner;
    if (!state || state.closing) return Promise.resolve();
    state.closing = true;
    state.cleanup();
    if (state.returnFocus && document.contains(state.returnFocus)) {
      try { state.returnFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
    return animateTo(state.el, 'closed').then(function () {
      state.el.remove();
      if (openBanner === state) {
        openBanner = null;
        setAnnouncementIndex('');
      }
    });
  }

  function showBanner(item, cart, quantity, trigger) {
    var template = document.querySelector('[data-templates] [data-atc-banner]');
    var host = document.querySelector('[data-site-header]');
    if (!template || !host) return false;

    var flyOut = template.cloneNode(true);
    flyOut.setAttribute('data-sk-atc-banner', '');
    flyOut.setAttribute('data-animation-state', 'closed');
    fillBanner(flyOut, item, cart, quantity);

    var state = { el: flyOut, closing: false, returnFocus: trigger || document.activeElement };

    function onClick(e) {
      if (e.target === flyOut) closeBanner();
    }
    function onCloseButton(e) {
      e.preventDefault();
      closeBanner();
    }
    function onKey(e) {
      if (e.key === 'Escape') {
        closeBanner();
        return;
      }
      if (e.key !== 'Tab') return;
      var list = focusables(flyOut);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (!flyOut.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    function onCloseAll() { closeBanner(); }

    var closeBtn = flyOut.querySelector('[data-atc-banner-close]');
    if (closeBtn) closeBtn.addEventListener('click', onCloseButton);
    flyOut.addEventListener('click', onClick);
    window.addEventListener('keydown', onKey);

    state.cleanup = function () {
      if (closeBtn) closeBtn.removeEventListener('click', onCloseButton);
      flyOut.removeEventListener('click', onClick);
      window.removeEventListener('keydown', onKey);
      document.removeEventListener('closeFlyouts', onCloseAll);
    };

    setAnnouncementIndex('1100');
    host.appendChild(flyOut);
    openBanner = state;
    document.addEventListener('closeFlyouts', onCloseAll);

    animateTo(flyOut, 'open').then(function () {
      if (openBanner !== state || state.closing) return;
      var list = focusables(flyOut);
      if (list.length) {
        try { list[0].focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
    });
    return true;
  }

  function showError(message) {
    var template = document.querySelector('[data-templates] [data-message-banner]');
    var modal = document.querySelector('.modal-loaded .modal-inner');
    var host = modal || document.querySelector('[data-site-header]');
    if (!template || !host) return;
    var banner = template.cloneNode(true);
    banner.setAttribute('data-sk-message-banner', '');
    banner.setAttribute('data-animation-state', 'closed');
    banner.classList.add('message--error');
    setText(banner, '[data-message-banner-content]', message);
    host.appendChild(banner);

    var closed = false;
    function close() {
      if (closed) return;
      closed = true;
      document.removeEventListener('click', onDoc);
      window.removeEventListener('keydown', onKey);
      animateTo(banner, 'closed').then(function () { banner.remove(); });
    }
    function onDoc(e) {
      if (!banner.contains(e.target) || e.target.closest('[data-message-banner-close]')) close();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('click', onDoc);
    window.addEventListener('keydown', onKey);
    animateTo(banner, 'open');
  }

  /* ---------- Cart ---------- */
  function setBusy(trigger, busy) {
    if (!trigger) return;
    if (busy) {
      trigger.setAttribute('aria-busy', 'true');
      if ('disabled' in trigger) trigger.disabled = true;
      trigger.classList.add('is-busy');
    } else {
      trigger.removeAttribute('aria-busy');
      if ('disabled' in trigger) trigger.disabled = false;
      trigger.classList.remove('is-busy');
    }
  }

  /* One request: /cart/add.js also returns the sidebar's markup (sections), so the sidebar opens as
     soon as the add answers; the header badge's /cart.js runs alongside (SK-56: was three in a row). */
  function add(variantId, qty, trigger) {
    var quantity = parseInt(qty, 10) || 1;
    var id = Number(variantId);
    var drawer = SK.cartDrawer && typeof SK.cartDrawer.open === 'function' ? SK.cartDrawer : null;
    setBusy(trigger, true);
    var added;
    var body = { items: [{ id: id, quantity: quantity }] };
    if (drawer) { body.sections = ['sk-cart-drawer']; body.sections_url = route('cart_url', '/cart'); }
    return fetch(route('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || data.status) {
            var err = new Error('cart/add');
            err.skDescription = data && typeof data.description === 'string' ? data.description : '';
            throw err;
          }
          added = data;
          document.dispatchEvent(new Event('closeFlyouts'));
          if (drawer) {
            var markup = data.sections && data.sections['sk-cart-drawer'];
            drawer.open({ trigger: trigger, html: markup || undefined });
            setBusy(trigger, false);
          }
          return fetch(route('cart_url', '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function (cart) {
        window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
        if (!drawer) {
          var item = (added && added.items && added.items[0]) || added || {};
          showBanner(item, cart, quantity, trigger);
        }
        setBusy(trigger, false);
        return cart;
      })
      .catch(function (err) {
        setBusy(trigger, false);
        var fallback = (cfg().strings && cfg().strings.atcError) || "Couldn't add to cart. Please try again.";
        showError((err && err.skDescription) || fallback);
        throw err;
      });
  }

  /* ---------- Public API ---------- */
  var SK = window.SK = window.SK || {};
  SK.__core = true;
  SK.reducedMotion = reducedMotion;
  Object.defineProperty(SK, 'inEditor', { get: inEditor, configurable: true, enumerable: true });
  SK.observeOnce = observeOnce;
  SK.formatMoney = formatMoney;
  SK.bezier = bezier;
  SK.cart = SK.cart || {};
  SK.cart.add = add;
  SK.cart.close = closeBanner;

  /* ---------- <sk-reveal> ---------- */
  function reveal(el) { el.classList.add('is-in'); }

  if (!customElements.get('sk-reveal')) {
    customElements.define('sk-reveal', class extends HTMLElement {
      connectedCallback() {
        if (this.classList.contains('is-in')) return;
        if (inEditor()) {
          reveal(this);
          return;
        }
        var self = this;
        /* default trigger: 8% into the viewport (mtstorelb); sections may set a px data-margin */
        this._skOff = observeOnce(this, this.getAttribute('data-margin') || '0px 0px -8% 0px', function () {
          self._skOff = null;
          reveal(self);
        });
      }
      disconnectedCallback() {
        if (this._skOff) {
          this._skOff();
          this._skOff = null;
        }
      }
    });
  }

  /* ---------- Delegated quick-add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sk-atc]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    add(id, btn.getAttribute('data-quantity') || 1, btn).catch(function () { /* surfaced by the error banner */ });
  });

  /* ---------- Sign in on the storefront: Shopify's <shopify-account> sheet (10 Oct 2026) ----------
     [data-sk-account-open="<selector>"] buttons open the sheet of that component (default: the
     header's); without a working component the button's own href (the sign-in page) takes over.
     The sign-in page opens its sheet by itself; a signed-in visitor there goes on to My orders. */
  function accountComponent(sel) {
    var el = (sel && document.querySelector(sel)) || document.querySelector('.site-header shopify-account') || document.querySelector('shopify-account');
    return el && typeof el.showModal === 'function' ? el : null;
  }
  function openAccount(sel) {
    var el = accountComponent(sel);
    if (!el) return false;
    var drawer = document.querySelector('sk-mobile-drawer');
    if (drawer && typeof drawer.close === 'function') { try { drawer.close(true); } catch (err) { /* not open */ } }
    try { el.showModal(); } catch (err) { return false; }
    return true;
  }
  SK.openAccount = openAccount;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sk-account-open]') : null;
    if (!btn) return;
    if (openAccount(btn.getAttribute('data-sk-account-open'))) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  /* The sign-in page: Shopify's panel is shown inline in the page. The component opens it as a modal
     dialog; we re-open the same dialog non-modal, so it sits in the column under the text with no
     backdrop. It builds itself in steps (a skeleton, the email form, then Sign in with Shop), changing
     height each time, so until it is complete it stays unseen and inert (no focus, no scroll) over a
     placeholder card of its final size, then fades in once (.is-ready): nothing jumps (SK-54).
     Opening it the component also locks the page's scrolling (<html> overflow/touch-action), sets a
     --dialog-min-height for its phone drawer, and closes it whenever it thinks it is hidden (while the
     panel is unseen). Inline here its dialog's showModal() is a plain show(), the page's styles are put
     back right after, and close() does nothing; all undone if the page falls back. Its X is hidden; if
     it closes anyway it is shown again. Without the component the link to Shopify's sign-in shows
     (.is-fallback). */
  function signinPage() {
    var pg = document.querySelector('[data-sk-signin-page]');
    if (!pg) return;
    var next = pg.getAttribute('data-sk-signed-in');
    if (next) { window.location.replace(next); return; }
    var box = pg.querySelector('[data-sk-signin]');
    var el = box && box.querySelector('.sks-account');
    if (!el) return;
    var state = 'loading';
    var undo = null;
    var settle = function (to) {
      if (state !== 'loading') return;
      state = to;
      if (to === 'fallback' && undo) undo();
      /* what follows the panel: if the finished panel is not the placeholder's height, it slides, not jumps */
      var below = [];
      for (var n = box.nextElementSibling; n; n = n.nextElementSibling) if (n.getClientRects().length) below.push(n);
      var before = below.length ? below[0].getBoundingClientRect().top : 0;
      el.inert = false;
      box.classList.remove('is-loading');
      box.classList.add(to === 'ready' ? 'is-ready' : 'is-fallback');
      if (to !== 'ready' || !below.length || !below[0].animate || reducedMotion()) return;
      var shift = before - below[0].getBoundingClientRect().top;
      if (Math.abs(shift) < 2) return;
      below.forEach(function (n) {
        n.animate([{ transform: 'translateY(' + shift + 'px)' }, { transform: 'none' }], { duration: 450, easing: 'cubic-bezier(.16, 1, .3, 1)' });
      });
    };
    if (!(window.customElements && customElements.whenDefined)) { settle('fallback'); return; }
    var late = setTimeout(function () { settle('fallback'); }, 8000);
    customElements.whenDefined('shopify-account').then(function () {
      clearTimeout(late);
      if (state !== 'loading' || typeof el.showModal !== 'function') { settle('fallback'); return; }
      var dialog = function () { return el.shadowRoot && el.shadowRoot.querySelector('dialog'); };
      var find = function (root, test) {
        var all = root.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
          if (test(all[i])) return all[i];
          if (all[i].shadowRoot) { var hit = find(all[i].shadowRoot, test); if (hit) return hit; }
        }
        return null;
      };
      var isSkeleton = function (n) { return n.classList.contains('account__skeleton-line'); };
      var isEmail = function (n) { return n.tagName === 'INPUT' && n.type === 'email'; };
      var isShop = function (n) {
        return n.tagName === 'SHOP-LOGIN' && !!n.shadowRoot &&
          [].some.call(n.shadowRoot.querySelectorAll('button'), function (b) { return b.offsetHeight > 0; });
      };
      var inline = function () {
        var d = dialog();
        if (!d) return false;
        if (d.open && d.matches(':modal')) d.close();
        if (!d.open) d.show();
        pg.classList.add('is-inline');
        if (!d.skInline) {
          d.skInline = true;
          /* the dialog's own close does not reach the host, so listen on the dialog itself */
          d.addEventListener('close', function () { setTimeout(function () { if (!d.open) d.show(); }, 0); });
          try {
            var sheet = new CSSStyleSheet();
            sheet.replaceSync('.account__close { display: none !important; }');
            el.shadowRoot.adoptedStyleSheets = el.shadowRoot.adoptedStyleSheets.concat(sheet);
          } catch (err) { /* the X stays; closing just shows the panel again */ }
        }
        return true;
      };
      /* complete: no skeleton and Sign in with Shop drawn, or (no Shop) the email form still for 2.5s; at most 6s */
      var watch = function () {
        var t0 = Date.now(), still = t0, lastH = -1;
        (function tick() {
          if (state !== 'loading') return;
          var d = dialog(), now = Date.now();
          var h = d && d.open ? d.offsetHeight : 0;
          if (h !== lastH) { lastH = h; still = now; }
          var busy = !d || d.classList.contains('closing') || find(el.shadowRoot, isSkeleton);
          if (h > 0 && !busy && ((now - still >= 150 && find(el.shadowRoot, isShop)) || (now - still >= 2500 && find(el.shadowRoot, isEmail)))) { settle('ready'); return; }
          if (now - t0 >= 6000) { settle(h > 0 ? 'ready' : 'fallback'); return; }
          setTimeout(tick, 100);
        })();
      };
      el.inert = true;
      var d0 = dialog();
      var ownClose = Object.prototype.hasOwnProperty.call(el, 'close');
      el.close = function () { return el; };
      if (d0) {
        d0.showModal = function () {
          var st = html.style, was = [st.overflow, st.touchAction, st.scrollbarGutter];
          if (!d0.open) d0.show();
          Promise.resolve().then(function () {
            st.overflow = was[0];
            st.touchAction = was[1];
            st.scrollbarGutter = was[2];
            d0.style.removeProperty('--dialog-min-height');
          });
        };
      }
      undo = function () {
        if (d0) delete d0.showModal;
        if (!ownClose) delete el.close;
      };
      try { el.showModal(); } catch (err) { settle('fallback'); return; }
      requestAnimationFrame(function () {
        if (inline()) { watch(); return; }
        setTimeout(function () { if (inline()) watch(); else settle('fallback'); }, 400);
      });
    }).catch(function () { settle('fallback'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', signinPage);
  else signinPage();
  /* the theme editor re-renders the section: set the new copy up again */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-sk-signin-page]')) signinPage();
  });

  /* ---------- Reduced motion (media query + Empire's body[data-reduce-animations]) ---------- */
  function syncMotion() {
    var reduced = reducedMotion();
    html.classList.toggle('sk-reduced-motion', reduced);
    document.dispatchEvent(new CustomEvent('sk:reduced-motion', { detail: { reduced: reduced } }));
  }
  html.classList.toggle('sk-reduced-motion', reducedMotion());
  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', syncMotion);
    else if (mq.addListener) mq.addListener(syncMotion);
  }
  document.addEventListener('DOMContentLoaded', function () {
    html.classList.toggle('sk-reduced-motion', reducedMotion());
  });

  /* ---------- Endless animations wait while off-screen (SK-63) ----------
     The brand strip, the About page strip and the hero's timer bar get .is-offscreen when they are more than
     200px outside the screen; their CSS pauses the animation, so a phone does no work for what nobody sees. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var SEL = '.sk-brands__strip, .sk-story-marquee__viewport, sk-hero';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-offscreen', !e.isIntersecting); });
    }, { rootMargin: '200px 0px' });
    function watch(root) {
      if (!root || !root.querySelectorAll) return;
      Array.prototype.forEach.call(root.querySelectorAll(SEL), function (el) {
        if (el._skOffscreen) return;
        el._skOffscreen = true;
        io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(document); });
    else watch(document);
    document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
  })();

  /* ---------- Theme editor helpers ---------- */
  function revealWithin(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('sk-reveal')) reveal(root);
    root.querySelectorAll('sk-reveal').forEach(reveal);
  }
  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var target = e.target;
      revealWithin(target);
      if (target && target.closest) {
        var host = target.closest('sk-reveal');
        if (host) reveal(host);
      }
    });
  });
})();
} catch (skBundleError) {
  if (window.console) console.error('[sk-bundle] sk-core.js', skBundleError);
}

/* ===== sk-carousel.js ===== */
try {
/*
 * SawaKart theme: <sk-carousel> and <sk-hero> (package P2).
 *
 * <sk-carousel> re-implements the parts of embla-carousel 8.6.0 that the FE
 * ProductCarousel uses ({align:'start', slidesToScroll:1, containScroll:'trimSnaps',
 * loop:false, dragThreshold:10, duration:25}) with embla's own constants, so the
 * snapping, drag, flick and edge rubber-band feel the same. No library.
 *
 * <sk-hero> is mtstorelb.com's hero (9 Oct 2026): full-width slides that slide
 * sideways in an endless loop, copy that enters as its slide arrives, progress
 * bars that time the autoplay, a Pause button, drag/swipe and arrow keys.
 *
 * Both elements set themselves up in connectedCallback and clean up in
 * disconnectedCallback, so theme-editor section reloads need no extra code.
 */
(function () {
  'use strict';

  function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
  }
  function isMouseEvent(evt) {
    return typeof window.MouseEvent !== 'undefined' && evt instanceof window.MouseEvent;
  }
  /* embla factorAbs */
  function factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if (Math.abs(valueB) <= Math.abs(valueA)) return 0;
    return Math.abs((Math.abs(valueB) - Math.abs(valueA)) / valueB);
  }

  var FIXED_STEP = 1000 / 60;
  var BASE_DURATION = 25;
  var BASE_FRICTION = 0.68;
  var DRAG_THRESHOLD = 10;
  var LOG_INTERVAL = 170;
  var PIXEL_TOLERANCE = 2;
  var FOCUS_NODES = ['INPUT', 'SELECT', 'TEXTAREA'];
  var NON_PASSIVE = { passive: false };
  var PASSIVE = { passive: true };

  /* ------------------------------------------------------------------ */
  /* <sk-carousel>                                                       */
  /* ------------------------------------------------------------------ */

  class SkCarousel extends HTMLElement {
    constructor() {
      super();
      this._tick = this._tick.bind(this);
      this._onDown = this._onDown.bind(this);
      this._onMove = this._onMove.bind(this);
      this._onUp = this._onUp.bind(this);
      this._onClick = this._onClick.bind(this);
      this._onDragStart = function (evt) { evt.preventDefault(); };
      this._noop = function () {};
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onVisibility = this._onVisibility.bind(this);
      this._onSlideFocus = this._onSlideFocus.bind(this);
      this._onPrev = this.scrollPrev.bind(this);
      this._onNext = this.scrollNext.bind(this);
    }

    connectedCallback() {
      if (this._connected) return;
      this.viewport = this.querySelector('.sk-pcar__viewport');
      this.container = this.viewport && this.viewport.querySelector('.sk-pcar__container');
      if (!this.container) return;
      this._connected = true;
      this.prevBtn = this.querySelector('.sk-pcar__arrow--prev');
      this.nextBtn = this.querySelector('.sk-pcar__arrow--next');
      this.thumb = this.querySelector('.sk-pcar__thumb');
      this.slides = Array.prototype.slice.call(this.container.children);

      this.raf = 0;
      this.lastTs = null;
      this.acc = 0;
      this.pointerIsDown = false;
      this.preventScroll = false;
      this.preventClick = false;
      this.isMouse = false;
      this.dragNode = null;
      this.lastTabPress = 0;
      this.index = 0;

      var vp = this.viewport;
      vp.addEventListener('dragstart', this._onDragStart, NON_PASSIVE);
      vp.addEventListener('touchmove', this._noop, NON_PASSIVE);
      vp.addEventListener('touchend', this._noop, PASSIVE);
      vp.addEventListener('touchstart', this._onDown, PASSIVE);
      vp.addEventListener('mousedown', this._onDown, PASSIVE);
      vp.addEventListener('touchcancel', this._onUp, PASSIVE);
      vp.addEventListener('contextmenu', this._onUp, PASSIVE);
      vp.addEventListener('click', this._onClick, true);
      var self = this;
      this.slides.forEach(function (slide) {
        slide.addEventListener('focus', self._onSlideFocus, { passive: true, capture: true });
      });
      document.addEventListener('keydown', this._onKeyDown, false);
      document.addEventListener('visibilitychange', this._onVisibility);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);

      this._activate(0);

      if (typeof ResizeObserver !== 'undefined') {
        this.ro = new ResizeObserver(function (entries) {
          if (!self._connected) return;
          for (var i = 0; i < entries.length; i++) {
            var node = entries[i].target;
            var last = self._sizes.get(node);
            if (last === undefined) continue;
            if (Math.abs(node.offsetWidth - last) >= 0.5) {
              self.reInit();
              break;
            }
          }
        });
        var nodes = [this.container].concat(this.slides);
        this._roFrame = requestAnimationFrame(function () {
          self._roFrame = 0;
          if (!self._connected) return;
          nodes.forEach(function (n) { self.ro.observe(n); });
        });
      }
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      this._stop();
      this._clearDragEvents();
      if (this._roFrame) cancelAnimationFrame(this._roFrame);
      if (this.ro) this.ro.disconnect();
      this.ro = null;
      var vp = this.viewport;
      vp.removeEventListener('dragstart', this._onDragStart, NON_PASSIVE);
      vp.removeEventListener('touchmove', this._noop, NON_PASSIVE);
      vp.removeEventListener('touchend', this._noop, PASSIVE);
      vp.removeEventListener('touchstart', this._onDown, PASSIVE);
      vp.removeEventListener('mousedown', this._onDown, PASSIVE);
      vp.removeEventListener('touchcancel', this._onUp, PASSIVE);
      vp.removeEventListener('contextmenu', this._onUp, PASSIVE);
      vp.removeEventListener('click', this._onClick, true);
      var self = this;
      this.slides.forEach(function (slide) {
        slide.removeEventListener('focus', self._onSlideFocus, { passive: true, capture: true });
      });
      document.removeEventListener('keydown', this._onKeyDown, false);
      document.removeEventListener('visibilitychange', this._onVisibility);
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext);
    }

    /* ---------- measurement (embla SlideSizes / ScrollSnaps / ScrollContain / ScrollLimit) ---------- */

    _measure() {
      var slides = this.slides;
      var n = slides.length;
      var viewSize = this.container.offsetWidth;
      this.viewSize = viewSize;
      this._sizes = new Map();
      this._sizes.set(this.container, viewSize);
      slides.forEach(function (s) { this._sizes.set(s, s.offsetWidth); }, this);

      if (!n) {
        this.snaps = [0];
        this.limitMin = 0;
        this.limitMax = 0;
        this.registry = [];
        return;
      }
      /* The container is position:relative, so offsetLeft is container-relative
         (embla: containerRect.left − slideRect.left with a shared offsetParent). */
      var lefts = slides.map(function (s) { return s.offsetLeft; });
      var sizes = slides.map(function (s) { return s.offsetWidth; });
      var snaps = lefts.map(function (l) { return -Math.abs(l); });
      var startGap = Math.abs(lefts[0]);
      var endGap = parseFloat(window.getComputedStyle(slides[n - 1]).getPropertyValue('margin-right')) || 0;
      var lastWithGap;
      if (n === 1) lastWithGap = sizes[0] + startGap;
      else lastWithGap = sizes[n - 1] + endGap;
      var contentSize = -snaps[n - 1] + lastWithGap;

      /* ScrollContain (trimSnaps) */
      var bMin = -contentSize + viewSize;
      var bMax = 0;
      var bounded = snaps.map(function (snapAligned, i) {
        var snap = snapAligned < bMin ? bMin : snapAligned > bMax ? bMax : snapAligned;
        if (i === 0) return bMax;
        if (i === n - 1) return bMin;
        if (Math.abs(bMin - snap) <= 1) return bMin;
        if (Math.abs(bMax - snap) <= 1) return bMax;
        return snap;
      }).map(function (v) { return parseFloat(v.toFixed(3)); });
      var cMin = bounded.lastIndexOf(bounded[0]);
      var cMax = bounded.indexOf(bounded[bounded.length - 1]) + 1;
      var contained;
      if (contentSize <= viewSize + PIXEL_TOLERANCE) contained = [bMax];
      else contained = bounded.slice(cMin, cMax);

      this.snaps = contained;
      this.limitMax = contained[0];
      this.limitMin = contained[contained.length - 1];

      /* SlideRegistry: slide index -> snap index (used by watchFocus) */
      var registry = [];
      var lastGroup = contained.length - 1;
      for (var i = 0; i < n; i++) {
        if (contained.length === 1 || i <= cMin) registry.push(0);
        else if (i >= cMax - 1) registry.push(lastGroup);
        else registry.push(i - cMin);
      }
      this.registry = registry;
    }

    _activate(startIndex) {
      this._measure();
      var last = this.snaps.length - 1;
      this.index = clamp(startIndex || 0, 0, last);
      var start = this.snaps[this.index];
      this.location = start;
      this.previousLocation = start;
      this.offsetLocation = start;
      this.target = start;
      this.velocity = 0;
      this.duration = BASE_DURATION;
      this.friction = BASE_FRICTION;
      this._translated = null;
      this.goToNextThreshold = clamp(this.viewSize * 0.2, 50, 225);
      this._translate(this.location);
      this._syncUi();
    }

    reInit() {
      if (!this._connected) return;
      var start = this.index;
      this._stop();
      this._clearDragEvents();
      this.pointerIsDown = false;
      this.preventScroll = false;
      this.isMouse = false;
      this.container.style.transform = '';
      this._activate(start);
      if (this.ro) {
        var self = this;
        this.ro.disconnect();
        [this.container].concat(this.slides).forEach(function (n) { self.ro.observe(n); });
      }
    }

    /* ---------- UI (FE onSelect / onScroll handlers) ---------- */

    _syncUi() {
      this._updateButtons();
      this._updateProgress();
    }

    _updateButtons() {
      var canPrev = this.canScrollPrev();
      var canNext = this.canScrollNext();
      if (this.prevBtn) this.prevBtn.disabled = !canPrev;
      if (this.nextBtn) this.nextBtn.disabled = !canNext;
      if (canPrev || canNext) this.setAttribute('data-scrollable', '');
      else this.removeAttribute('data-scrollable');
    }

    _updateProgress() {
      if (!this.thumb) return;
      var length = Math.abs(this.limitMin - this.limitMax);
      var p = length ? (this.offsetLocation - this.limitMax) / -length : 0;
      p = clamp(p, 0, 1);
      this.thumb.style.transform = 'translateX(' + p * 300 + '%)';
    }

    canScrollPrev() {
      return clamp(this.index - 1, 0, this.snaps.length - 1) !== this.index;
    }

    canScrollNext() {
      return clamp(this.index + 1, 0, this.snaps.length - 1) !== this.index;
    }

    /* ---------- limits ---------- */

    _reachedMin(n) { return n < this.limitMin; }
    _reachedMax(n) { return n > this.limitMax; }
    _reachedAny(n) { return n < this.limitMin || n > this.limitMax; }
    _constrain(n) {
      if (!this._reachedAny(n)) return n;
      return n < this.limitMin ? this.limitMin : this.limitMax;
    }

    /* ---------- ScrollBounds ---------- */

    _shouldConstrain() {
      return this._reachedAny(this.target) && this._reachedAny(this.offsetLocation);
    }

    _constrainBounds(pointerDown) {
      if (!this._shouldConstrain()) return;
      var loc = this.offsetLocation;
      var edge = this._reachedMin(loc) ? this.limitMin : this.limitMax;
      var diffToEdge = Math.abs(edge - loc);
      var diffToTarget = this.target - loc;
      var friction = clamp(diffToEdge / (this.viewSize * 0.5), 0.1, 0.99);
      this.target -= diffToTarget * friction;
      if (!pointerDown && Math.abs(diffToTarget) < this.viewSize * 0.1) {
        this.target = this._constrain(this.target);
        this.duration = 25;
        this.friction = BASE_FRICTION;
      }
    }

    /* ---------- ScrollBody ---------- */

    _seek() {
      var displacement = this.target - this.location;
      if (!this.duration) {
        this.velocity = 0;
        this.previousLocation = this.target;
        this.location = this.target;
      } else {
        this.previousLocation = this.location;
        this.velocity += displacement / this.duration;
        this.velocity *= this.friction;
        this.location += this.velocity;
      }
    }

    _settled() {
      return Math.abs(this.target - this.offsetLocation) < 0.001;
    }

    /* ---------- engine update / render ---------- */

    _update() {
      this._constrainBounds(this.pointerIsDown);
      this._seek();
    }

    _render(alpha) {
      var hasSettled = this._settled() && !this._shouldConstrain();
      var idle = hasSettled && !this.pointerIsDown;
      if (idle) this._stop();
      this.offsetLocation = this.location * alpha + this.previousLocation * (1 - alpha);
      this._translate(this.offsetLocation);
      if (!hasSettled) this._updateProgress();
    }

    _translate(n) {
      var value = Math.round(n * 100) / 100;
      if (value === this._translated) return;
      this.container.style.transform = 'translate3d(' + value + 'px,0px,0px)';
      this._translated = value;
    }

    /* ---------- Animations (fixed 60 Hz step + interpolation) ---------- */

    _start() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(this._tick);
    }

    _stop() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.lastTs = null;
      this.acc = 0;
      this.raf = 0;
    }

    _tick(ts) {
      if (!this.raf) return;
      if (!this.lastTs) {
        this.lastTs = ts;
        this._update();
        this._update();
      }
      var elapsed = ts - this.lastTs;
      this.lastTs = ts;
      this.acc += elapsed;
      while (this.acc >= FIXED_STEP) {
        this._update();
        this.acc -= FIXED_STEP;
      }
      this._render(this.acc / FIXED_STEP);
      if (this.raf) this.raf = requestAnimationFrame(this._tick);
    }

    _onVisibility() {
      if (document.hidden) {
        this.lastTs = null;
        this.acc = 0;
      }
    }

    /* ---------- ScrollTarget / ScrollTo ---------- */

    _byDistance(distance, snap) {
      var t = this.target + distance;
      var d = this._constrain(t);
      var best = 0;
      var bestDiff = Infinity;
      for (var i = 0; i < this.snaps.length; i++) {
        var diff = Math.abs(this.snaps[i] - d);
        if (diff < bestDiff) {
          bestDiff = diff;
          best = i;
        }
      }
      if (!snap || this._reachedAny(t)) return { index: best, distance: distance };
      return { index: best, distance: distance + (this.snaps[best] - d) };
    }

    _byIndex(index) {
      return { index: index, distance: this.snaps[index] - this.target };
    }

    _scrollTo(t) {
      this.target += t.distance;
      if (t.distance) {
        if (this.duration) {
          this._start();
        } else {
          this._update();
          this._render(1);
          this._update();
        }
      }
      if (t.index !== this.index) {
        this.index = t.index;
        this._updateButtons();
      }
    }

    scrollTo(index, jump) {
      if (!this._connected) return;
      this.friction = BASE_FRICTION;
      this.duration = jump === true ? 0 : BASE_DURATION;
      this._scrollTo(this._byIndex(clamp(index, 0, this.snaps.length - 1)));
    }

    scrollNext() {
      this.scrollTo(this.index + 1);
    }

    scrollPrev() {
      this.scrollTo(this.index - 1);
    }

    /* ---------- DragHandler + DragTracker ---------- */

    _point(evt, axis) {
      var src = isMouseEvent(evt) ? evt : evt.touches && evt.touches[0];
      if (!src) return 0;
      return axis === 'y' ? src.clientY : src.clientX;
    }

    _snapshot(evt) {
      return { x: this._point(evt), t: evt.timeStamp };
    }

    _addDragEvents() {
      var node = this.isMouse ? document : this.viewport;
      this.dragNode = node;
      node.addEventListener('touchmove', this._onMove, NON_PASSIVE);
      node.addEventListener('touchend', this._onUp, PASSIVE);
      node.addEventListener('mousemove', this._onMove, NON_PASSIVE);
      node.addEventListener('mouseup', this._onUp, PASSIVE);
    }

    _clearDragEvents() {
      var node = this.dragNode;
      if (!node) return;
      node.removeEventListener('touchmove', this._onMove, NON_PASSIVE);
      node.removeEventListener('touchend', this._onUp, PASSIVE);
      node.removeEventListener('mousemove', this._onMove, NON_PASSIVE);
      node.removeEventListener('mouseup', this._onUp, PASSIVE);
      this.dragNode = null;
    }

    _onDown(evt) {
      var isMouseEvt = isMouseEvent(evt);
      this.isMouse = isMouseEvt;
      this.preventClick = false;
      if (isMouseEvt && evt.button !== 0) return;
      if (FOCUS_NODES.indexOf(evt.target && evt.target.nodeName) > -1) return;
      this._clearDragEvents();
      this.pointerIsDown = true;
      this.trackStart = this._snapshot(evt);
      this.trackLast = this.trackStart;
      this.friction = 0;
      this.duration = 0;
      this.target = this.location;
      this._addDragEvents();
      this.startScroll = this._point(evt);
      this.startCross = this._point(evt, 'y');
    }

    _onMove(evt) {
      var isTouchEvt = !isMouseEvent(evt);
      if (isTouchEvt && evt.touches.length >= 2) return this._onUp(evt);
      var lastScroll = this._point(evt);
      var lastCross = this._point(evt, 'y');
      var diffScroll = Math.abs(lastScroll - this.startScroll);
      var diffCross = Math.abs(lastCross - this.startCross);
      if (!this.preventScroll && !this.isMouse) {
        if (!evt.cancelable) return this._onUp(evt);
        this.preventScroll = diffScroll > diffCross;
        if (!this.preventScroll) return this._onUp(evt);
      }
      /* DragTracker.pointerMove */
      var snap = this._snapshot(evt);
      var diff = snap.x - this.trackLast.x;
      var expired = snap.t - this.trackStart.t > LOG_INTERVAL;
      this.trackLast = snap;
      if (expired) this.trackStart = snap;

      if (diffScroll > DRAG_THRESHOLD) this.preventClick = true;
      this.friction = 0.3;
      this.duration = 0.75;
      this._start();
      this.target += diff;
      evt.preventDefault();
    }

    _trackerUp(evt) {
      var start = this.trackStart;
      var last = this.trackLast;
      if (!start || !last) return 0;
      var diffDrag = last.x - start.x;
      var diffTime = evt.timeStamp - start.t;
      var expired = evt.timeStamp - last.t > LOG_INTERVAL;
      var force = diffDrag / diffTime;
      var isFlick = diffTime && !expired && Math.abs(force) > 0.1;
      return isFlick ? force : 0;
    }

    _allowedForce(force) {
      var next = clamp(this.index + Math.sign(force) * -1, 0, this.snaps.length - 1);
      var baseForce = this._byDistance(force, true).distance;
      if (Math.abs(force) < this.goToNextThreshold) return baseForce;
      return this._byIndex(next).distance;
    }

    _onUp(evt) {
      var rawForce = this._trackerUp(evt) * (this.isMouse ? 300 : 400);
      var force = this._allowedForce(rawForce);
      var forceFactor = factorAbs(rawForce, force);
      var speed = BASE_DURATION - 10 * forceFactor;
      var friction = BASE_FRICTION + forceFactor / 50;
      this.preventScroll = false;
      this.pointerIsDown = false;
      this._clearDragEvents();
      this.duration = speed;
      this.friction = friction;
      this._scrollTo(this._byDistance(force, true));
      this.isMouse = false;
    }

    _onClick(evt) {
      if (this.preventClick) {
        evt.stopPropagation();
        evt.preventDefault();
        this.preventClick = false;
      }
    }

    /* ---------- SlideFocus (watchFocus) ---------- */

    _onKeyDown(evt) {
      if (evt.code === 'Tab') this.lastTabPress = new Date().getTime();
    }

    _onSlideFocus(evt) {
      if (new Date().getTime() - this.lastTabPress > 10) return;
      var i = this.slides.indexOf(evt.currentTarget);
      if (i < 0) return;
      this.viewport.scrollLeft = 0;
      var group = this.registry[i];
      if (typeof group !== 'number') return;
      this.duration = 0;
      this._scrollTo(this._byIndex(group));
    }
  }

  if (!customElements.get('sk-carousel')) customElements.define('sk-carousel', SkCarousel);

  /* ------------------------------------------------------------------ */
  /* <sk-hero>                                                           */
  /* ------------------------------------------------------------------ */
  /*
   * mtstorelb.com's hero (9 Oct 2026). The slides sit side by side in a track and changing slide
   * slides the track (.75s on cubic-bezier(.16,1,.3,1), the curve measured on their site). The
   * loop is endless: at rest the current slide is second in the track, and slides that are out of
   * view move from one end of the track to the other (the picture on screen never moves), so
   * there is always a slide on both sides. The active progress bar fills over the interval and
   * its animationend moves on, so pausing the bar (Pause button, a drag) pauses the slideshow.
   * A slide's copy enters as it arrives. Drag/swipe and the arrow keys move too; no autoplay
   * for reduced motion; in the theme editor a selected slide stays.
   */
  var HERO_DRAG_START = 8;      /* px before a press becomes a horizontal drag */
  var HERO_SWIPE_SHARE = 0.12;  /* share of the width that changes the slide on release */
  var HERO_FLICK_SPEED = 0.4;   /* px/ms that changes the slide whatever the distance */
  var HERO_EDITOR_EVENTS = ['shopify:block:select', 'shopify:block:deselect', 'shopify:section:select', 'shopify:section:deselect'];

  function heroReducedMotion() {
    return !!((window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      (document.body && document.body.hasAttribute('data-reduce-animations')));
  }

  class SkHero extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onKey = this._onKey.bind(this);
      this._onAnimEnd = this._onAnimEnd.bind(this);
      this._onTransEnd = this._onTransEnd.bind(this);
      this._onDown = this._onDown.bind(this);
      this._onMove = this._onMove.bind(this);
      this._onUp = this._onUp.bind(this);
      this._onEditor = this._onEditor.bind(this);
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      var self = this;
      this.track = this.querySelector('.sk-hero__track');
      /* in slide order (data-index), whatever order the loop has left them in the track */
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.sk-hero__slide')).sort(function (a, b) {
        return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0);
      });
      this.count = this.slides.length;
      if (!this.track || !this.count) return;
      this.bars = Array.prototype.slice.call(this.querySelectorAll('.sk-hero__bar'));
      this.pauseBtn = this.querySelector('.sk-hero__pause');
      var ms = parseInt(this.getAttribute('data-autoplay'), 10);
      this.ms = ms > 0 ? ms : 6000;
      this.style.setProperty('--sk-hero-ms', this.ms + 'ms');
      this.reduced = heroReducedMotion();
      this.paused = false;
      this.editorHold = false;
      this.moving = false;
      this._drag = null;
      var active = this.querySelector('.sk-hero__slide.is-active');
      this.current = Math.max(0, this.slides.indexOf(active));
      this.pos = this._posOf(this.slides[this.current]);

      if (this.count > 1) {
        this._normalize();
        this.addEventListener('click', this._onClick, true);
        this.addEventListener('keydown', this._onKey);
        this.addEventListener('animationend', this._onAnimEnd);
        this.track.addEventListener('transitionend', this._onTransEnd);
        this.addEventListener('pointerdown', this._onDown);
        HERO_EDITOR_EVENTS.forEach(function (name) { document.addEventListener(name, self._onEditor); });
      }
      this._setActive(this.current);
      this._showCopy(this.slides[this.current]);

      /* the first picture settles once (CSS animation); then nothing re-runs it */
      clearTimeout(this._settleTimer);
      this._settleTimer = setTimeout(function () { self.classList.add('is-settled'); }, 2400);
      /* SK-63: only the neighbours are fetched ahead (next and previous), 1.5 s after the first picture or at
         the first touch; every slide change fetches the new neighbours. No slide arrives empty, and a phone no
         longer downloads all the pictures up front. */
      clearTimeout(this._loadTimer);
      this._loadTimer = setTimeout(function () {
        self._warmReady = true;
        self._warmAround(self.current);
      }, 1500);
      if (!this._warmBound) {
        this._warmBound = true;
        this.addEventListener('pointerdown', function () {
          self._warmReady = true;
          self._warmAround(self.current);
        }, { passive: true });
      }
      this._run();
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this._connected = false;
      var self = this;
      clearTimeout(this._settleTimer);
      clearTimeout(this._loadTimer);
      clearTimeout(this._swallowTimer);
      clearTimeout(this._waitTimer);
      this._endDrag();
      this.removeEventListener('click', this._onClick, true);
      this.removeEventListener('keydown', this._onKey);
      this.removeEventListener('animationend', this._onAnimEnd);
      if (this.track) this.track.removeEventListener('transitionend', this._onTransEnd);
      this.removeEventListener('pointerdown', this._onDown);
      HERO_EDITOR_EVENTS.forEach(function (name) { document.removeEventListener(name, self._onEditor); });
    }

    /* ---------- track position ---------- */

    _posOf(el) {
      return Array.prototype.indexOf.call(this.track.children, el);
    }

    /* move the track to position p (fractional while dragging), animated or at once */
    _set(p, animate) {
      this.pos = p;
      this.track.classList.toggle('is-moving', !!animate && !this.reduced);
      this.track.style.transform = 'translate3d(' + (-100 * p) + '%, 0, 0)';
    }

    /* where the track is right now, in slides (fractional while a move runs) */
    _livePos() {
      var m = window.getComputedStyle(this.track).transform;
      var w = this.track.getBoundingClientRect().width || 1;
      if (!m || m === 'none') return 0;
      var v = m.slice(m.indexOf('(') + 1, -1).split(',');
      var x = parseFloat(v.length === 16 ? v[12] : v[4]) || 0;
      return -x / w;
    }

    /* stop a running move where it is (the picture stays still) */
    _freeze() {
      if (!this.moving) return;
      this.moving = false;
      this._set(this._livePos(), false);
      void this.track.offsetWidth;
    }

    /* at rest the current slide is second in the track, so both neighbours are ready;
       the slides moved are out of view, and the transform follows, so nothing moves on screen */
    _normalize() {
      var t = this.track;
      var guard = this.count;
      var p = this._posOf(this.slides[this.current]);
      while (p > 1 && guard-- > 0) { t.appendChild(t.firstElementChild); p--; }
      while (p < 1 && guard-- > 0) { t.insertBefore(t.lastElementChild, t.firstElementChild); p++; }
      this._set(p, false);
    }

    /* ---------- moving ---------- */

    next() { this.goTo(this.current + 1, 1); }
    prev() { this.goTo(this.current - 1, -1); }

    /* go to slide `index`: dir 1 forward, -1 backward, 0 the shorter way round */
    goTo(index, dir) {
      var n = this.count;
      if (n < 2 || !this._connected) return;
      var t = this.track;
      var target = ((index % n) + n) % n;
      this._freeze();
      var fwd = (target - this.current + n) % n;
      var back = (this.current - target + n) % n;
      if (!dir) dir = fwd <= back ? 1 : -1;
      var curPos = this._posOf(this.slides[this.current]);
      var dest = curPos + (dir > 0 ? fwd : -back);
      /* make room on the side the track is heading to, with slides that are out of view */
      var guard = n;
      while (dest > n - 1 && this.pos >= 1 && guard-- > 0) {
        t.appendChild(t.firstElementChild);
        dest--;
        this._set(this.pos - 1, false);
      }
      while (dest < 0 && this.pos <= n - 2 && guard-- > 0) {
        t.insertBefore(t.lastElementChild, t.firstElementChild);
        dest++;
        this._set(this.pos + 1, false);
      }
      /* no room that way (a long move asked for in the middle of another): go straight to the
         slide where it is, so a move never lands on another picture and then jumps */
      if (dest < 0 || dest > n - 1) dest = this._posOf(this.slides[target]);
      this._arrive(target);
      this._moveTo(dest);
    }

    /* slide `target` becomes the current one: its bar runs, its copy enters (unless still on show) */
    _arrive(target) {
      var slide = this.slides[target];
      this.current = target;
      this._setActive(target);
      var copy = slide.querySelector('.sk-hero__copy');
      if (copy && !copy.classList.contains('is-shown')) this._showCopy(slide);
      this._run();
    }

    /* slide the track to position `dest` (at once for reduced motion) */
    _moveTo(dest) {
      if (this.reduced || Math.abs(this.pos - dest) < 0.001) {
        this._set(dest, false);
        this._rest();
        return;
      }
      void this.track.offsetWidth; /* commit the start position so the move animates from it */
      this.moving = true;
      this._set(dest, true);
    }

    _onTransEnd(evt) {
      if (evt.target !== this.track || evt.propertyName !== 'transform' || !this.moving) return;
      this._rest();
    }

    /* after a move: current slide back to second place; slides out of view replay their copy next time */
    _rest() {
      this.moving = false;
      this._normalize();
      var cur = this.slides[this.current];
      this.slides.forEach(function (s) {
        if (s === cur) return;
        var c = s.querySelector('.sk-hero__copy');
        if (c) c.classList.remove('is-shown');
      });
    }

    _setActive(index) {
      this.slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        if (on) s.classList.remove('is-cold'); /* SK-71: a shown slide always has its picture */
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert');
        else s.setAttribute('inert', '');
      });
      if (this._warmReady) this._warmAround(index);
    }

    _warmAround(index) {
      var n = this.slides.length;
      if (!n) return;
      [index, index + 1, index - 1].forEach(function (k) { /* the slide itself too: a bar jump goes straight to it */
        var s = this.slides[((k % n) + n) % n];
        if (s) s.classList.remove('is-cold'); /* SK-71: its picture exists (and loads) from now on */
        var img = s && s.querySelector('.sk-hero__img[loading="lazy"]');
        if (img) img.loading = 'eager';
      }, this);
    }

    _showCopy(slide) {
      var copy = slide && slide.querySelector('.sk-hero__copy');
      if (!copy) return;
      copy.classList.remove('is-shown');
      void copy.offsetWidth; /* commit the hidden state so the entrance runs */
      copy.classList.add('is-shown');
    }

    /* ---------- progress bars (the autoplay timer) ---------- */

    _run() {
      var self = this;
      this.bars.forEach(function (b, i) {
        b.setAttribute('aria-current', i === self.current ? 'true' : 'false');
        var f = b.firstElementChild;
        if (f) f.removeAttribute('data-run');
      });
      if (this.count < 2 || this.reduced || this.paused || this.editorHold || !this._connected) return;
      var fill = this.bars[this.current] && this.bars[this.current].firstElementChild;
      if (!fill) return;
      void fill.offsetWidth; /* restart the fill animation */
      fill.setAttribute('data-run', 'true');
    }

    _onAnimEnd(evt) {
      if (evt.animationName !== 'sk-hero-fill' || !evt.target.getAttribute || evt.target.getAttribute('data-run') !== 'true') return;
      this._nextWhenReady(0);
    }

    /* SK-71: autoplay moves on only once the next slide's photo is there (it is fetched ahead, but on a slow
       connection it can still be on its way); it checks every 0.3 s and goes anyway after 8 s. A tap on a bar,
       an arrow key or a swipe still moves at once. */
    _nextWhenReady(waited) {
      var self = this;
      var n = this.slides.length;
      if (!n || !this._connected) return;
      if (this.paused || this.editorHold) { this._pendingNext = true; return; }
      this._pendingNext = false;
      var k = (this.current + 1) % n;
      var img = this.slides[k] && this.slides[k].querySelector('.sk-hero__img');
      if (!img || (img.complete && img.naturalWidth > 0) || waited >= 8000) {
        this.next();
        return;
      }
      if (!this._warmReady) {
        this._warmReady = true;
        this._warmAround(this.current);
      }
      clearTimeout(this._waitTimer);
      this._waitTimer = setTimeout(function () { self._nextWhenReady(waited + 300); }, 300);
    }

    _togglePause() {
      this.paused = !this.paused;
      if (this.paused) this.setAttribute('data-paused', '');
      else this.removeAttribute('data-paused');
      if (this.pauseBtn) {
        this.pauseBtn.textContent = this.paused ? 'Play' : 'Pause';
        this.pauseBtn.setAttribute('aria-pressed', this.paused ? 'true' : 'false');
      }
      if (!this.paused && this._pendingNext) {
        /* SK-71: paused while waiting for the next photo: carry on from there */
        this._nextWhenReady(0);
        return;
      }
      if (!this.paused) {
        /* a bar paused mid-way resumes where it stopped; otherwise it starts again */
        var fill = this.bars[this.current] && this.bars[this.current].firstElementChild;
        if (!fill || fill.getAttribute('data-run') !== 'true') this._run();
      }
    }

    /* ---------- input ---------- */

    _onClick(evt) {
      if (this._swallowClick) {
        /* the click that ends a drag must not follow the slide link */
        this._swallowClick = false;
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }
      var btn = evt.target.closest ? evt.target.closest('.sk-hero__bar, .sk-hero__pause') : null;
      if (!btn || !this.contains(btn)) return;
      if (btn.classList.contains('sk-hero__pause')) this._togglePause();
      else this.goTo(this.bars.indexOf(btn), 0);
    }

    _onKey(evt) {
      if (evt.defaultPrevented || evt.altKey || evt.ctrlKey || evt.metaKey) return;
      if (evt.key === 'ArrowRight') { evt.preventDefault(); this.next(); }
      else if (evt.key === 'ArrowLeft') { evt.preventDefault(); this.prev(); }
    }

    _onDown(evt) {
      if (this.count < 2 || this._drag || evt.isPrimary === false) return;
      if (evt.pointerType === 'mouse' && evt.button !== 0) return;
      if (evt.target.closest && evt.target.closest('.sk-hero__nav')) return;
      this._drag = {
        id: evt.pointerId, x: evt.clientX, y: evt.clientY, on: false, start: 0, dx: 0,
        lx: evt.clientX, lt: evt.timeStamp, v: 0, w: this.getBoundingClientRect().width || 1
      };
      window.addEventListener('pointermove', this._onMove, PASSIVE);
      window.addEventListener('pointerup', this._onUp);
      window.addEventListener('pointercancel', this._onUp);
    }

    _onMove(evt) {
      var d = this._drag;
      if (!d || evt.pointerId !== d.id) return;
      var dx = evt.clientX - d.x;
      var dy = evt.clientY - d.y;
      if (!d.on) {
        if (Math.abs(dy) > HERO_DRAG_START && Math.abs(dy) > Math.abs(dx)) { this._endDrag(); return; } /* a scroll */
        if (Math.abs(dx) < HERO_DRAG_START) return;
        d.on = true;
        this._freeze();
        this._prepareDrag(dx < 0);
        d.start = this.pos;
        this.setAttribute('data-dragging', '');
      }
      var dt = evt.timeStamp - d.lt;
      if (dt > 0) { d.v = (evt.clientX - d.lx) / dt; d.lx = evt.clientX; d.lt = evt.timeStamp; }
      d.dx = dx;
      this._set(Math.max(0, Math.min(this.count - 1, d.start - dx / d.w)), false);
    }

    /* a slide must be ready on the side the drag heads to (two slides: move the other one over) */
    _prepareDrag(forward) {
      var t = this.track;
      var n = this.count;
      if (forward && this.pos > n - 2 && this.pos >= 1) {
        t.appendChild(t.firstElementChild);
        this._set(this.pos - 1, false);
      } else if (!forward && this.pos < 1 && this.pos <= n - 2) {
        t.insertBefore(t.lastElementChild, t.firstElementChild);
        this._set(this.pos + 1, false);
      }
    }

    _onUp(evt) {
      var d = this._drag;
      if (!d || (evt.pointerId !== undefined && evt.pointerId !== d.id)) return;
      this._endDrag();
      if (!d.on) return;
      this.removeAttribute('data-dragging');
      var self = this;
      if (evt.type === 'pointerup') {
        this._swallowClick = true;
        clearTimeout(this._swallowTimer);
        this._swallowTimer = setTimeout(function () { self._swallowClick = false; }, 400);
      }
      /* settle next to where the drag let go: the slide ahead / behind after a swipe or a flick,
         else the nearer one (a short drag goes back); grabbing a move half-way works the same */
      var share = -d.dx / d.w;
      var flick = Math.abs(d.v) > HERO_FLICK_SPEED;
      var dest;
      if (share > HERO_SWIPE_SHARE || (flick && d.v < 0 && d.dx < 0)) dest = Math.ceil(this.pos - 0.001);
      else if (share < -HERO_SWIPE_SHARE || (flick && d.v > 0 && d.dx > 0)) dest = Math.floor(this.pos + 0.001);
      else dest = Math.round(this.pos);
      dest = Math.max(0, Math.min(this.count - 1, dest));
      var target = this.slides.indexOf(this.track.children[dest]);
      /* back on the same slide, its bar goes on from where the drag paused it */
      if (target > -1 && target !== this.current) this._arrive(target);
      this._moveTo(dest);
    }

    _endDrag() {
      window.removeEventListener('pointermove', this._onMove, PASSIVE);
      window.removeEventListener('pointerup', this._onUp);
      window.removeEventListener('pointercancel', this._onUp);
      this._drag = null;
    }

    /* Theme editor: a selected slide stays; selecting the section pauses autoplay. */
    _onEditor(evt) {
      /* section events come from the section around the hero, block events from the slide itself */
      var el = evt.target;
      if (!el || !el.contains || !(el.contains(this) || this.contains(el))) return;
      switch (evt.type) {
        case 'shopify:block:select': {
          var id = evt.detail && evt.detail.blockId;
          var i = this.slides.findIndex(function (s) { return s.getAttribute('data-block-id') === id; });
          this.editorHold = true;
          if (i > -1 && i !== this.current) this.goTo(i, 0);
          else this._run();
          break;
        }
        case 'shopify:section:select':
          this.editorHold = true;
          this._run();
          break;
        default:
          this.editorHold = false;
          this._run();
      }
    }
  }

  if (!customElements.get('sk-hero')) customElements.define('sk-hero', SkHero);
})();
} catch (skBundleError) {
  if (window.console) console.error('[sk-bundle] sk-carousel.js', skBundleError);
}

/* ===== sk-sections-2.js ===== */
try {
/* ==========================================================================
   SawaKart sections, part 2 (P3): <sk-featured-gallery>, <sk-ig-feed>,
   <sk-parallax>, <sk-countup> + theme-editor hooks for the brands marquee.
   Loaded with `defer` after sk-core.js; window.SK is used when present, with
   local fallbacks so these components never break on their own.
   ========================================================================== */
(function () {
  'use strict';

  var RM_QUERY = '(prefers-reduced-motion: reduce)';
  var rmMedia = window.matchMedia ? window.matchMedia(RM_QUERY) : null;

  function sk() { return window.SK || null; }

  function reducedMotion() {
    var api = sk();
    if (api && typeof api.reducedMotion === 'function') {
      try { return !!api.reducedMotion(); } catch (e) { /* fall through */ }
    }
    return !!(rmMedia && rmMedia.matches) ||
      !!(document.body && document.body.hasAttribute('data-reduce-animations'));
  }

  /* IntersectionObserver once, rootMargin on all sides (framer whileInView). */
  function observeOnce(el, margin, cb) {
    var api = sk();
    var done = false;
    var guarded = function () { if (!done && el.isConnected) { done = true; cb(); } };
    if (api && typeof api.observeOnce === 'function') {
      var stop = api.observeOnce(el, margin, guarded);
      return function () { done = true; if (typeof stop === 'function') stop(); };
    }
    if (!('IntersectionObserver' in window)) { guarded(); return function () {}; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { io.disconnect(); guarded(); break; }
      }
    }, { rootMargin: margin + 'px', threshold: 0 });
    io.observe(el);
    return function () { done = true; io.disconnect(); };
  }

  /* UnitBezier solver (WebKit), used when SK.bezier is missing. */
  function localBezier(p1x, p1y, p2x, p2y) {
    var cx = 3 * p1x, bx = 3 * (p2x - p1x) - cx, ax = 1 - cx - bx;
    var cy = 3 * p1y, by = 3 * (p2y - p1y) - cy, ay = 1 - cy - by;
    function sx(t) { return ((ax * t + bx) * t + cx) * t; }
    function sy(t) { return ((ay * t + by) * t + cy) * t; }
    function dx(t) { return (3 * ax * t + 2 * bx) * t + cx; }
    function solveX(x) {
      var t = x, i, x2, d2;
      for (i = 0; i < 8; i++) {
        x2 = sx(t) - x;
        if (Math.abs(x2) < 1e-6) return t;
        d2 = dx(t);
        if (Math.abs(d2) < 1e-6) break;
        t = t - x2 / d2;
      }
      var lo = 0, hi = 1;
      t = x;
      while (lo < hi) {
        x2 = sx(t);
        if (Math.abs(x2 - x) < 1e-6) return t;
        if (x > x2) lo = t; else hi = t;
        t = (hi - lo) / 2 + lo;
        if (hi - lo < 1e-7) break;
      }
      return t;
    }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      return sy(solveX(x));
    };
  }

  function bezier(a, b, c, d) {
    var api = sk();
    if (api && typeof api.bezier === 'function') {
      try { var fn = api.bezier(a, b, c, d); if (typeof fn === 'function') return fn; } catch (e) { /* fall back */ }
    }
    return localBezier(a, b, c, d);
  }

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function define(name, ctor) {
    if (!customElements.get(name)) customElements.define(name, ctor);
  }

  /* ------------------------------------------------------------------------
     <sk-featured-gallery>: thumbnails, crossfade, drag-x swipe (S04 §7.4)
     ------------------------------------------------------------------------ */
  var DRAG_ELASTIC = 0.18;
  var SWIPE_MIN = 50;
  var SPRING_BACK = 'transform .4s cubic-bezier(.25,1,.5,1)';

  class SkFeaturedGallery extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('.sk-fp__frame');
      this.layers = Array.prototype.slice.call(this.querySelectorAll('.sk-fp__layer[data-index]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.sk-fp__thumb'));
      this.counter = this.querySelector('[data-sk-fp-current]');
      this.count = this.layers.length;
      this.active = 0;
      for (var i = 0; i < this.layers.length; i++) {
        if (this.layers[i].classList.contains('is-active')) { this.active = i; break; }
      }

      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);

      if (this.frame && this.count > 1) {
        this._down = this._down.bind(this);
        this._move = this._move.bind(this);
        this._up = this._up.bind(this);
        this._dragStart = function (e) { e.preventDefault(); };
        this.frame.addEventListener('pointerdown', this._down);
        this.frame.addEventListener('pointermove', this._move);
        this.frame.addEventListener('pointerup', this._up);
        this.frame.addEventListener('pointercancel', this._up);
        this.frame.addEventListener('lostpointercapture', this._up);
        this.frame.addEventListener('dragstart', this._dragStart);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      if (this.frame && this._down) {
        this.frame.removeEventListener('pointerdown', this._down);
        this.frame.removeEventListener('pointermove', this._move);
        this.frame.removeEventListener('pointerup', this._up);
        this.frame.removeEventListener('pointercancel', this._up);
        this.frame.removeEventListener('lostpointercapture', this._up);
        this.frame.removeEventListener('dragstart', this._dragStart);
      }
      this.drag = null;
    }

    go(index) {
      var n = this.count;
      if (n < 2) return;
      var i = ((index % n) + n) % n;
      if (i === this.active) return;
      this.layers[this.active].classList.remove('is-active');
      this.layers[i].classList.add('is-active');
      for (var t = 0; t < this.thumbs.length; t++) {
        this.thumbs[t].setAttribute('aria-current', t === i ? 'true' : 'false');
      }
      if (this.counter) this.counter.textContent = pad2(i + 1);
      this.active = i;
    }

    _onClick(e) {
      var thumb = e.target.closest('.sk-fp__thumb');
      if (!thumb || !this.contains(thumb)) return;
      this.go(parseInt(thumb.getAttribute('data-index'), 10) || 0);
    }

    _down(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      this.drag = { id: e.pointerId, x: e.clientX, dx: 0 };
      this.frame.style.transition = 'none';
      try { this.frame.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      if (e.pointerType === 'mouse') e.preventDefault();
    }

    _move(e) {
      var d = this.drag;
      if (!d || e.pointerId !== d.id) return;
      d.dx = e.clientX - d.x;
      this.frame.style.transform = 'translateX(' + (d.dx * DRAG_ELASTIC) + 'px)';
    }

    _up(e) {
      var d = this.drag;
      if (!d || e.pointerId !== d.id) return;
      this.drag = null;
      try { this.frame.releasePointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      this.frame.style.transition = reducedMotion() ? 'none' : SPRING_BACK;
      this.frame.style.transform = 'translateX(0px)';
      if (e.type === 'pointerup' && Math.abs(d.dx) >= SWIPE_MIN) {
        this.go(this.active + (d.dx < 0 ? 1 : -1));
      }
    }
  }
  define('sk-featured-gallery', SkFeaturedGallery);

  /* ------------------------------------------------------------------------
     <sk-ig-feed>: arrow state + scrollBy (S04 §9.4)
     ------------------------------------------------------------------------ */
  class SkIgFeed extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('.sk-ig__row');
      this.prev = this.querySelector('.sk-ig__arrow--prev');
      this.next = this.querySelector('.sk-ig__arrow--next');
      if (!this.row) return;
      this._update = this._update.bind(this);
      this._onClick = this._onClick.bind(this);
      this.row.addEventListener('scroll', this._update, { passive: true });
      window.addEventListener('resize', this._update);
      window.addEventListener('load', this._update);
      this.addEventListener('click', this._onClick);
      this._update();
    }

    disconnectedCallback() {
      if (!this.row) return;
      this.row.removeEventListener('scroll', this._update);
      window.removeEventListener('resize', this._update);
      window.removeEventListener('load', this._update);
      this.removeEventListener('click', this._onClick);
    }

    _update() {
      var row = this.row;
      var offset = Math.abs(row.scrollLeft);
      if (this.prev) this.prev.disabled = !(offset > 4);
      if (this.next) this.next.disabled = !(offset + row.clientWidth < row.scrollWidth - 4);
    }

    _onClick(e) {
      var btn = e.target.closest('.sk-ig__arrow');
      if (!btn || !this.contains(btn)) return;
      this.step(btn === this.next ? 1 : -1);
    }

    step(dir) {
      var card = this.row.firstElementChild;
      if (!card) return;
      this.row.scrollBy({ left: (card.offsetWidth + 16) * dir, behavior: 'smooth' });
    }
  }
  define('sk-ig-feed', SkIgFeed);

  /* ------------------------------------------------------------------------
     <sk-parallax data-distance="d">: translateY(d·(1−2p)), one shared loop.
     p = (vh − top) / (vh + h), clamped; top = untransformed document offset
     (offsetTop chain ignores transforms, like framer's useScroll).
     d may be a share of the element's own height ("-6%": banner photos).
     data-mode="exit": translateY(d*q), q = 0 to 1 while the element's top leaves the
     top of the screen (the hero drifting down as it scrolls away, mtstorelb).
     data-media="(min-width: 768px)": moves only while the query matches.
     ------------------------------------------------------------------------ */
  var plxEls = new Set();
  var plxRaf = 0;
  var plxBound = false;
  var plxResizeObserver = null;

  function plxMeasure(el) {
    var top = 0;
    var node = el;
    while (node) { top += node.offsetTop; node = node.offsetParent; }
    el._skTop = top;
    el._skH = el.offsetHeight;
    el._skD = el._skPct === null ? el._skBaseD : el._skPct / 100 * el._skH;
  }

  function plxUpdate() {
    plxRaf = 0;
    var off = reducedMotion();
    var vh = window.innerHeight;
    var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
    plxEls.forEach(function (el) {
      if (off || (el._skMq && !el._skMq.matches)) {
        if (el.style.transform) el.style.transform = '';
        return;
      }
      var top = el._skTop - sy;
      var y;
      if (el._skExit) {
        var q = el._skH ? -top / el._skH : 0;
        q = q < 0 ? 0 : (q > 1 ? 1 : q);
        y = el._skD * q;
      } else {
        var p = (vh - top) / (vh + el._skH);
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
        y = el._skD * (1 - 2 * p);
      }
      el.style.transform = 'translateY(' + y.toFixed(2) + 'px)';
    });
  }

  function plxSchedule() { if (!plxRaf) plxRaf = requestAnimationFrame(plxUpdate); }
  function plxRemeasure() { plxEls.forEach(plxMeasure); plxSchedule(); }

  function plxBind() {
    if (plxBound) return;
    plxBound = true;
    window.addEventListener('scroll', plxSchedule, { passive: true });
    window.addEventListener('resize', plxRemeasure);
    window.addEventListener('load', plxRemeasure);
    if (rmMedia) {
      if (rmMedia.addEventListener) rmMedia.addEventListener('change', plxRemeasure);
      else if (rmMedia.addListener) rmMedia.addListener(plxRemeasure);
    }
    if ('ResizeObserver' in window && document.body) {
      plxResizeObserver = new ResizeObserver(function () { plxRemeasure(); });
      plxResizeObserver.observe(document.body);
    }
  }

  function plxUnbind() {
    if (!plxBound) return;
    plxBound = false;
    window.removeEventListener('scroll', plxSchedule);
    window.removeEventListener('resize', plxRemeasure);
    window.removeEventListener('load', plxRemeasure);
    if (rmMedia) {
      if (rmMedia.removeEventListener) rmMedia.removeEventListener('change', plxRemeasure);
      else if (rmMedia.removeListener) rmMedia.removeListener(plxRemeasure);
    }
    if (plxResizeObserver) { plxResizeObserver.disconnect(); plxResizeObserver = null; }
    if (plxRaf) { cancelAnimationFrame(plxRaf); plxRaf = 0; }
  }

  class SkParallax extends HTMLElement {
    connectedCallback() {
      var dist = this.getAttribute('data-distance') || '';
      this._skBaseD = parseFloat(dist) || 0;
      this._skPct = /%\s*$/.test(dist) ? this._skBaseD : null;
      this._skD = this._skBaseD;
      this._skExit = this.getAttribute('data-mode') === 'exit';
      var media = this.getAttribute('data-media');
      this._skMq = media && window.matchMedia ? window.matchMedia(media) : null;
      plxEls.add(this);
      plxBind();
      plxMeasure(this);
      plxSchedule();
    }

    disconnectedCallback() {
      plxEls.delete(this);
      this.style.transform = '';
      if (!plxEls.size) plxUnbind();
    }
  }
  define('sk-parallax', SkParallax);

  /* ------------------------------------------------------------------------
     <sk-countup data-value data-suffix>: 0 → value over 1.8s on view (-60px)
     ------------------------------------------------------------------------ */
  var COUNT_MS = 1800;

  class SkCountup extends HTMLElement {
    connectedCallback() {
      this._text = this.querySelector('[data-sk-countup-text]');
      this._value = parseFloat(this.getAttribute('data-value'));
      this._suffix = this.getAttribute('data-suffix') || '';
      if (!this._text || !isFinite(this._value) || reducedMotion()) return;
      var self = this;
      this._stop = observeOnce(this, -60, function () {
        if (!reducedMotion()) self._run();
      });
    }

    disconnectedCallback() {
      if (this._stop) { this._stop(); this._stop = null; }
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = 0; }
    }

    _format(n) { return Math.round(n).toLocaleString('en-US') + this._suffix; }

    _run() {
      var self = this;
      var ease = bezier(0.16, 1, 0.3, 1);
      var start = 0;
      this._text.textContent = this._format(0);
      var tick = function (now) {
        if (!start) start = now;
        var t = Math.min(1, (now - start) / COUNT_MS);
        self._text.textContent = self._format(self._value * ease(t));
        self._raf = t < 1 ? requestAnimationFrame(tick) : 0;
      };
      this._raf = requestAnimationFrame(tick);
    }
  }
  define('sk-countup', SkCountup);

  /* ------------------------------------------------------------------------
     Theme editor: pause the brand marquee while its section or a brand block
     is selected; bring a selected brand / Instagram post into view.
     ------------------------------------------------------------------------ */
  function strips(root) {
    return root && root.querySelectorAll ? root.querySelectorAll('.sk-brands__strip') : [];
  }

  function seekBrand(card) {
    var strip = card.closest('.sk-brands__strip');
    var track = card.closest('.sk-brands__track');
    if (!strip || !track || typeof track.getAnimations !== 'function') return;
    var anim = track.getAnimations()[0];
    if (!anim || !anim.effect) return;
    var half = track.scrollWidth / 2;
    var duration = Number(anim.effect.getTiming().duration) || 0;
    if (!half || !duration) return;
    var offset = Math.max(0, Math.min(half - 1, card.offsetLeft - 80));
    anim.currentTime = (offset / half) * duration;
  }

  document.addEventListener('shopify:section:select', function (e) {
    Array.prototype.forEach.call(strips(e.target), function (s) { s.classList.add('is-paused'); });
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    Array.prototype.forEach.call(strips(e.target), function (s) { s.classList.remove('is-paused'); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var brand = target.closest('.sk-brand');
    if (brand) {
      var strip = brand.closest('.sk-brands__strip');
      if (strip) strip.classList.add('is-paused');
      seekBrand(brand);
      return;
    }
    var card = target.closest('.sk-ig__card');
    if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var strip = target.closest('.sk-brands__strip');
    if (strip) strip.classList.remove('is-paused');
  });
})();

/* SK-63: the long text in a .sk-seo-card folds under "Read more" when it is taller than about 300px (shorter
   texts stay open, no button). Without JavaScript the text is simply shown in full. */
(function () {
  'use strict';
  function initMore(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sk-more]'), function (box) {
      if (box._skMore) return;
      var btn = box.parentNode && box.parentNode.querySelector('[aria-controls="' + box.id + '"]');
      if (!btn) return;
      box._skMore = true;
      if (box.scrollHeight <= 300) return;
      var label = btn.querySelector('[data-sk-more-label]');
      box.classList.add('is-collapsed');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = box.classList.contains('is-collapsed');
        box.classList.toggle('is-collapsed', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? 'Read less' : 'Read more';
        if (!open) {
          var card = box.closest('.sk-seo-card') || box;
          var top = card.getBoundingClientRect().top;
          if (top < 0) window.scrollBy({ top: top - 96, behavior: 'smooth' });
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initMore(document); });
  else initMore(document);
  document.addEventListener('shopify:section:load', function (e) { initMore(e.target); });
})();

/* SK-70: the brand strip ships each brand once (search engines and SEO checkers see 20 brand links, not 40);
   the second copy that the endless marquee needs (translateX 0 -> -50%) is made here: hidden from screen
   readers and the keyboard, without the theme editor's block attributes. The track only moves once it is
   doubled (.is-looped, sk-sections-2.css), so without this script the strip simply stands still. */
(function () {
  'use strict';
  function loop(root) {
    var tracks = root && root.querySelectorAll ? root.querySelectorAll('.sk-brands__track:not(.is-looped)') : [];
    Array.prototype.forEach.call(tracks, function (track) {
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;
      items.forEach(function (item) {
        var copy = item.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('tabindex', '-1');
        Array.prototype.slice.call(copy.attributes).forEach(function (a) {
          if (a.name.indexOf('data-shopify-editor') === 0) copy.removeAttribute(a.name);
        });
        track.appendChild(copy);
      });
      track.classList.add('is-looped');
    });
  }
  loop(document);
  document.addEventListener('shopify:section:load', function (e) { loop(e.target); });
})();
} catch (skBundleError) {
  if (window.console) console.error('[sk-bundle] sk-sections-2.js', skBundleError);
}

/* ===== sk-chrome.js ===== */
try {
/* SawaKart chrome (P4): <sk-announcement>, <sk-mega-nav>, <sk-mobile-drawer>, <sk-rewards>.
   Custom elements self-initialise (theme editor safe) and clean up in disconnectedCallback.
   Timings mirror the FE storefront (framer-motion values, see S05 §14). */
(function () {
  'use strict';

  var EASE_INOUT = 'cubic-bezier(.42,0,.58,1)'; /* framer default tween */
  var EASE_OUT = 'cubic-bezier(0,0,.58,1)'; /* framer "easeOut" */
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reduced() {
    if (window.SK && typeof window.SK.reducedMotion === 'function') return !!window.SK.reducedMotion();
    return !!((mqReduce && mqReduce.matches) || (document.body && 'reduceAnimations' in document.body.dataset));
  }
  function define(name, ctor) {
    if (!customElements.get(name)) customElements.define(name, ctor);
  }
  function animateEl(el, frames, opts) {
    if (!el || typeof el.animate !== 'function') return Promise.resolve();
    var a = el.animate(frames, opts);
    return a.finished.then(function () { return a; }, function () { return null; });
  }

  /* ------------------------------------------------------------------
     <sk-announcement>: rotate messages; exit (350ms) then enter (350ms)
     ------------------------------------------------------------------ */
  class SkAnnouncement extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      this.msgs = Array.prototype.slice.call(this.querySelectorAll('[data-sk-ann-msg]'));
      this.index = 0;
      for (var i = 0; i < this.msgs.length; i++) if (this.msgs[i].classList.contains('is-active')) this.index = i;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.paused = false;
      var self = this;
      var first = this.msgs[this.index];
      if (first) void window.getComputedStyle(first).opacity; /* flush the hidden start state */
      this._raf = requestAnimationFrame(function () { self.setAttribute('data-ready', ''); });
      this.start();
    }
    disconnectedCallback() {
      this._on = false;
      this.stop();
      clearTimeout(this._swapT);
      cancelAnimationFrame(this._raf);
    }
    start() {
      var self = this;
      this.stop();
      if (this.paused || this.msgs.length < 2) return;
      this._timer = setInterval(function () { self.show((self.index + 1) % self.msgs.length); }, this.interval);
    }
    stop() {
      clearInterval(this._timer);
      this._timer = null;
    }
    pause() { this.paused = true; this.stop(); }
    resume() { this.paused = false; this.start(); }
    _setVisible(el, on) {
      if (on) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
      var link = el.querySelector('a');
      if (link) { if (on) link.removeAttribute('tabindex'); else link.setAttribute('tabindex', '-1'); }
    }
    show(i, instant) {
      var cur = this.msgs[this.index];
      var nxt = this.msgs[i];
      if (!nxt) return;
      clearTimeout(this._swapT);
      var self = this;
      this.msgs.forEach(function (m) { if (m !== cur) m.classList.remove('is-leaving'); });
      if (instant) {
        this.msgs.forEach(function (m) { m.classList.remove('is-active', 'is-leaving'); self._setVisible(m, false); });
        nxt.classList.add('is-active');
        this._setVisible(nxt, true);
        this.index = i;
        return;
      }
      if (i === this.index) return;
      if (cur) {
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        this._setVisible(cur, false);
      }
      this.index = i;
      /* AnimatePresence mode="wait": the enter starts after the exit finished */
      this._swapT = setTimeout(function () {
        if (cur) cur.classList.remove('is-leaving');
        nxt.classList.add('is-active');
        self._setVisible(nxt, true);
      }, 350);
    }
  }
  define('sk-announcement', SkAnnouncement);

  /* ------------------------------------------------------------------
     <sk-mega-nav>: hover opens instantly (first level-2 pre-selected),
     140ms close delay after leaving row + panel, keyboard + touch support
     ------------------------------------------------------------------ */
  class SkMegaNav extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      var self = this;
      this.delay = parseInt(this.dataset.closeDelay, 10);
      if (isNaN(this.delay)) this.delay = 140;
      this.openKey = null;
      this.panels = {};
      Array.prototype.forEach.call(this.querySelectorAll('[data-sk-mega-panel]'), function (p) {
        self.panels[p.getAttribute('data-sk-mega-panel')] = p;
      });
      this.roots = Array.prototype.slice.call(this.querySelectorAll('[data-sk-mega-root]'));

      if (!this._bound) {
        this._bound = true;
        this.addEventListener('mouseenter', function () { self.cancelClose(); });
        this.addEventListener('mouseleave', function () { self.scheduleClose(); });
        this.roots.forEach(function (r) {
          r.addEventListener('mouseenter', function () { self.enterRoot(r); });
        });
        Array.prototype.forEach.call(this.querySelectorAll('[data-sk-mega-l2]'), function (l) {
          l.addEventListener('mouseenter', function () { self.select(l); });
        });
        this.addEventListener('focusin', function (e) {
          self.cancelClose();
          var r = e.target.closest('[data-sk-mega-root]');
          if (r) { if (self.openKey !== r.getAttribute('data-sk-mega-root')) self.enterRoot(r); return; }
          var l = e.target.closest('[data-sk-mega-l2]');
          if (l) self.select(l);
        });
        this.addEventListener('focusout', function (e) {
          if (!e.relatedTarget || !self.contains(e.relatedTarget)) self.scheduleClose();
        });
        this.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.openKey !== null) {
            var root = self.rootEl(self.openKey);
            self.close();
            if (root) root.focus();
            return;
          }
          var down = e.key === 'ArrowDown' && e.target.closest('[data-sk-mega-root]');
          if (down && !down.hasAttribute('data-sk-mega-leaf')) {
            /* keyboard entry into the open panel (addition; FE is hover-only) */
            e.preventDefault();
            self.enterRoot(down);
            var pnl = self.panels[down.getAttribute('data-sk-mega-root')];
            var firstL2 = pnl && pnl.querySelector('[data-sk-mega-l2]');
            if (firstL2) firstL2.focus();
            return;
          }
          var r = e.target.closest('span[data-sk-mega-root]');
          if (r && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            if (self.openKey === r.getAttribute('data-sk-mega-root')) self.close(); else self.enterRoot(r);
          }
        });
        this.addEventListener('pointerdown', function (e) {
          var r = e.target.closest('[data-sk-mega-root]');
          self._ptype = e.pointerType;
          self._wasOpen = !!(r && self.openKey === r.getAttribute('data-sk-mega-root'));
        }, true);
        this.addEventListener('click', function (e) {
          var r = e.target.closest('[data-sk-mega-root]');
          if (!r || r.hasAttribute('data-sk-mega-leaf')) return;
          if (r.tagName !== 'A') {
            /* non-navigating "#" root: click toggles */
            if (self._wasOpen && self._ptype !== 'mouse') self.close(); else self.enterRoot(r);
            return;
          }
          /* touch: first tap opens the panel, second tap follows the link */
          if ((self._ptype === 'touch' || self._ptype === 'pen') && !self._wasOpen) {
            e.preventDefault();
            self.enterRoot(r);
          }
        });
      }
      this._onDocDown = function (e) { if (self.openKey !== null && !self.contains(e.target)) self.close(); };
      this._onResize = function () { if (window.innerWidth < 768 && self.openKey !== null) self.close(); };
      document.addEventListener('pointerdown', this._onDocDown);
      window.addEventListener('resize', this._onResize);
    }
    disconnectedCallback() {
      this._on = false;
      clearTimeout(this._t);
      document.removeEventListener('pointerdown', this._onDocDown);
      window.removeEventListener('resize', this._onResize);
    }
    rootEl(key) {
      for (var i = 0; i < this.roots.length; i++) if (this.roots[i].getAttribute('data-sk-mega-root') === key) return this.roots[i];
      return null;
    }
    cancelClose() { clearTimeout(this._t); this._t = null; }
    scheduleClose() {
      var self = this;
      this.cancelClose();
      if (this.openKey === null) return;
      this._t = setTimeout(function () { self.close(); }, this.delay);
    }
    enterRoot(r) {
      this.cancelClose();
      var key = r.getAttribute('data-sk-mega-root');
      if (r.hasAttribute('data-sk-mega-leaf') || !this.panels[key]) { this.close(); return; }
      this.open(key);
    }
    open(key) {
      var panel = this.panels[key];
      if (!panel) return;
      if (this.openKey !== key) {
        if (this.openKey !== null) this._setState(this.openKey, false);
        this.openKey = key;
        this._setState(key, true);
      }
      var first = panel.querySelector('[data-sk-mega-l2]');
      if (first) this.select(first);
    }
    close() {
      this.cancelClose();
      if (this.openKey === null) return;
      this._setState(this.openKey, false);
      this.openKey = null;
    }
    _setState(key, on) {
      var panel = this.panels[key];
      var root = this.rootEl(key);
      if (panel) panel.classList.toggle('is-open', on);
      if (root) {
        root.classList.toggle('is-open', on);
        root.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
    }
    select(l2) {
      var panel = l2.closest('[data-sk-mega-panel]');
      if (!panel) return;
      var idx = l2.getAttribute('data-sk-mega-l2');
      Array.prototype.forEach.call(panel.querySelectorAll('[data-sk-mega-l2]'), function (el) {
        el.classList.toggle('is-selected', el.getAttribute('data-sk-mega-l2') === idx);
      });
      Array.prototype.forEach.call(panel.querySelectorAll('[data-sk-mega-pane]'), function (el) {
        el.hidden = el.getAttribute('data-sk-mega-pane') !== idx;
      });
    }
  }
  define('sk-mega-nav', SkMegaNav);

  /* ------------------------------------------------------------------
     <sk-mobile-drawer>: spring panel, stack levels (220ms out, then 220ms in)
     ------------------------------------------------------------------ */
  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  class SkMobileDrawer extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      var self = this;
      this.panel = this.querySelector('.sk-drawer__panel');
      this.titleEl = this.querySelector('[data-sk-drawer-title]');
      this.backBtn = this.querySelector('[data-sk-drawer-back]');
      this.foot = this.querySelector('[data-sk-drawer-foot]');
      this.rootLevel = this.querySelector('[data-sk-level="root"]');
      this.stack = [this.rootLevel];
      this.isOpen = false;
      if (!this._bound) {
        this._bound = true;
        this.addEventListener('click', function (e) {
          var push = e.target.closest('[data-sk-drawer-push]');
          if (push) {
            e.preventDefault();
            self._build();
            self.push(document.getElementById(push.getAttribute('data-sk-drawer-push')), e.detail === 0);
            return;
          }
          if (e.target.closest('[data-sk-drawer-back]')) { self.pop(e.detail === 0); return; }
          if (e.target.closest('[data-sk-drawer-close]')) { self.close(); return; }
          if (e.target.closest('[data-sk-drawer-link]')) self.close(true); /* navigation continues */
        });
      }
      /* bound on document while open, so Escape/Tab work even if focus fell back to <body> */
      this._onDocKey = function (e) {
        if (!self.isOpen) return;
        if (e.key === 'Escape') { e.stopPropagation(); self.close(); } else if (e.key === 'Tab') self._trap(e);
      };
      this._mq = window.matchMedia('(min-width: 768px)');
      this._onMq = function () { if (self._mq.matches && self.isOpen) self.close(true); };
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._onMq);
    }
    disconnectedCallback() {
      this._on = false;
      clearTimeout(this._hideT);
      if (this._mq && this._mq.removeEventListener) this._mq.removeEventListener('change', this._onMq);
      document.removeEventListener('keydown', this._onDocKey, true);
      if (this.isOpen) document.documentElement.classList.remove('sk-scroll-lock');
    }
    open(trigger) {
      if (this.isOpen) return;
      clearTimeout(this._hideT);
      this.isOpen = true;
      this.trigger = trigger || null;
      this._build();
      this._reset();
      this.hidden = false;
      document.documentElement.classList.add('sk-scroll-lock');
      void this.panel.offsetWidth; /* start from the closed transform */
      this.classList.add('is-open');
      document.addEventListener('keydown', this._onDocKey, true);
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
      try { this.panel.focus({ preventScroll: true }); } catch (err) { this.panel.focus(); }
    }
    close(skipFocus) {
      if (!this.isOpen) return;
      var self = this;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this._onDocKey, true);
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'false');
        if (!skipFocus) { try { this.trigger.focus({ preventScroll: true }); } catch (err) { this.trigger.focus(); } }
      }
      /* unmount after the spring (~400ms) and overlay (200ms) finished */
      this._hideT = setTimeout(function () {
        if (self.isOpen) return;
        self.hidden = true;
        self._reset();
        document.documentElement.classList.remove('sk-scroll-lock');
      }, reduced() ? 220 : 420);
    }
    /* SK-63: the levels below the first one are built from the desktop mega menu on the same page the first
       time the drawer opens (sk-mobile-drawer.liquid no longer prints them): a department's level lists its
       sub-menus with "Shop all"; a sub-menu with links gets its own level. Same ids, rows and links as the
       server-rendered levels had. */
    _build() {
      if (this._built) return;
      this._built = true;
      var body = this.querySelector('.sk-drawer__body');
      var mega = document.querySelector('sk-mega-nav');
      var chev = this.rootLevel && this.rootLevel.querySelector('.sk-drawer__chev');
      if (!body || !mega || !this.rootLevel) return;
      function el(tag, cls, attrs) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
        return n;
      }
      function label(text) {
        var s = el('span', 'sk-drawer__label');
        s.textContent = text;
        return s;
      }
      function level(id, title) {
        return el('nav', 'sk-drawer__level', { id: id, 'data-sk-level': '', 'data-sk-title': title, 'aria-label': title, hidden: '' });
      }
      function allLink(href, title) {
        var a = el('a', 'sk-drawer__all', { href: href, 'data-sk-drawer-link': '' });
        a.textContent = 'Shop all ' + title + ' →';
        return a;
      }
      function linkRow(href, text) {
        var a = el('a', 'sk-drawer__row', { href: href, 'data-sk-drawer-link': '' });
        a.appendChild(label(text));
        return a;
      }
      function textRow(text) {
        var s = el('span', 'sk-drawer__row');
        s.appendChild(label(text));
        return s;
      }
      function pushRow(id, text) {
        var b = el('button', 'sk-drawer__row', { type: 'button', 'data-sk-drawer-push': id });
        b.appendChild(label(text));
        if (chev) b.appendChild(chev.cloneNode(true));
        return b;
      }
      var frag = document.createDocumentFragment();
      Array.prototype.forEach.call(this.rootLevel.querySelectorAll('[data-sk-drawer-push][data-sk-root]'), function (btn) {
        var id = btn.getAttribute('data-sk-drawer-push');
        if (document.getElementById(id)) return; /* already in the page (an older cached page) */
        var n = btn.getAttribute('data-sk-root');
        var panel = mega.querySelector('[data-sk-mega-panel="' + n + '"]');
        if (!panel) return;
        var rootA = mega.querySelector('[data-sk-mega-root="' + n + '"]');
        var title = (btn.querySelector('.sk-drawer__label') || btn).textContent.trim();
        var nav = level(id, title);
        if (rootA && rootA.getAttribute('href')) nav.appendChild(allLink(rootA.getAttribute('href'), title));
        var ul = el('ul', '', { role: 'list' });
        var subs = [];
        Array.prototype.forEach.call(panel.querySelectorAll('.sk-mega__list > li > .sk-mega__l2'), function (l2) {
          var k = l2.getAttribute('data-sk-mega-l2');
          var text = (l2.querySelector('.sk-mega__l2-label') || l2).textContent.trim();
          var pane = panel.querySelector('[data-sk-mega-pane="' + k + '"]');
          var l3s = pane ? pane.querySelectorAll('.sk-mega__links .sk-mega__l3') : [];
          var href = l2.tagName === 'A' ? l2.getAttribute('href') : null;
          var li = el('li');
          if (l3s.length) {
            var subId = id + '-' + k;
            li.appendChild(pushRow(subId, text));
            var sub = level(subId, text);
            if (href) sub.appendChild(allLink(href, text));
            var ul3 = el('ul', '', { role: 'list' });
            Array.prototype.forEach.call(l3s, function (l3) {
              var li3 = el('li');
              /* SK-70: the name only (the menu link also carries its department for screen readers) */
              var l3text = (l3.querySelector('.sk-mega__l3-label') || l3).textContent.trim();
              li3.appendChild(l3.tagName === 'A' ? linkRow(l3.getAttribute('href'), l3text) : textRow(l3text));
              ul3.appendChild(li3);
            });
            sub.appendChild(ul3);
            subs.push(sub);
          } else if (href) {
            li.appendChild(linkRow(href, text));
          } else {
            li.appendChild(textRow(text));
          }
          ul.appendChild(li);
        });
        nav.appendChild(ul);
        frag.appendChild(nav);
        subs.forEach(function (sub) { frag.appendChild(sub); });
      });
      body.appendChild(frag);
    }

    _reset() {
      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('[data-sk-level]'), function (lv) {
        if (lv.getAnimations) lv.getAnimations().forEach(function (a) { a.cancel(); });
        var isRoot = lv === self.rootLevel;
        lv.hidden = !isRoot;
        lv.classList.toggle('is-current', isRoot);
        lv.scrollTop = 0;
      });
      this.stack = [this.rootLevel];
      this.animating = false;
      this._head();
    }
    _head() {
      var top = this.stack[this.stack.length - 1];
      var isRoot = this.stack.length === 1;
      if (this.titleEl) {
        this.titleEl.textContent = top.getAttribute('data-sk-title') || '';
        this.titleEl.classList.toggle('is-root', isRoot);
      }
      if (this.backBtn) this.backBtn.hidden = isRoot;
      if (this.foot) this.foot.hidden = !isRoot;
    }
    push(next, viaKeyboard) {
      if (!next || this.animating) return;
      var cur = this.stack[this.stack.length - 1];
      this.stack.push(next);
      this._head();
      this._swap(cur, next, 1).then(function () {
        if (viaKeyboard) { var f = next.querySelector(FOCUSABLE); if (f) f.focus(); }
      });
    }
    pop(viaKeyboard) {
      if (this.stack.length < 2 || this.animating) return;
      var self = this;
      var cur = this.stack.pop();
      var prev = this.stack[this.stack.length - 1];
      this._head();
      this._swap(cur, prev, -1).then(function () {
        if (viaKeyboard && self.backBtn) (self.backBtn.hidden ? self.panel : self.backBtn).focus();
      });
    }
    _swap(cur, next, dir) {
      var self = this;
      var r = reduced();
      var opts = { duration: 220, easing: EASE_OUT };
      var exitKf = r
        ? [{ opacity: 1 }, { opacity: 0 }]
        : [{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(' + (-dir * 100) + '%)', opacity: 0 }];
      var enterKf = r
        ? [{ opacity: 0 }, { opacity: 1 }]
        : [{ transform: 'translateX(' + (dir * 100) + '%)', opacity: 0 }, { transform: 'translateX(0)', opacity: 1 }];
      this.animating = true;
      return animateEl(cur, exitKf, Object.assign({ fill: 'forwards' }, opts)).then(function (a) {
        cur.hidden = true;
        cur.classList.remove('is-current');
        if (a) a.cancel();
        var active = document.activeElement;
        if (!active || active === document.body || (cur.contains(active))) {
          try { self.panel.focus({ preventScroll: true }); } catch (err) { self.panel.focus(); }
        }
        next.hidden = false;
        next.classList.add('is-current');
        next.scrollTop = 0;
        return animateEl(next, enterKf, opts);
      }).then(function () { self.animating = false; });
    }
    _trap(e) {
      var list = Array.prototype.filter.call(this.panel.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!list.length) { e.preventDefault(); return; }
      var first = list[0];
      var last = list[list.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || active === this.panel || !this.panel.contains(active))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && (active === last || !this.panel.contains(active))) {
        e.preventDefault(); first.focus();
      }
    }
  }
  define('sk-mobile-drawer', SkMobileDrawer);

  /* ------------------------------------------------------------------
     <sk-rewards>: pill toggles the loyalty panel (200ms), icon swap 150+150ms
     ------------------------------------------------------------------ */
  class SkRewards extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      var self = this;
      this.btn = this.querySelector('.sk-fw__trigger');
      this.panel = this.querySelector('.sk-fw__panel');
      this.gift = this.querySelector('.sk-fw__icon--gift');
      this.x = this.querySelector('.sk-fw__icon--x');
      this.isOpen = false;
      if (!this.btn || !this.panel) return;
      if (!this._bound) {
        this._bound = true;
        this.btn.addEventListener('click', function () { self.setOpen(!self.isOpen); });
      }
      this._onDoc = function (e) {
        if (self.isOpen && !self.panel.contains(e.target) && !self.btn.contains(e.target)) self.setOpen(false);
      };
      this._onKey = function (e) {
        if (e.key === 'Escape' && self.isOpen) { self.setOpen(false); self.btn.focus(); }
      };
      document.addEventListener('mousedown', this._onDoc);
      document.addEventListener('keydown', this._onKey);
    }
    disconnectedCallback() {
      this._on = false;
      clearTimeout(this._hideT);
      document.removeEventListener('mousedown', this._onDoc);
      document.removeEventListener('keydown', this._onKey);
    }
    setOpen(open) {
      if (open === this.isOpen) return;
      var self = this;
      this.isOpen = open;
      this.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      this._swapIcon(open);
      clearTimeout(this._hideT);
      if (open) {
        this.panel.hidden = false;
        void this.panel.offsetWidth;
        this.panel.classList.add('is-open');
      } else {
        this.panel.classList.remove('is-open');
        this._hideT = setTimeout(function () { if (!self.isOpen) self.panel.hidden = true; }, 200);
      }
    }
    _swapIcon(open) {
      if (!this.gift || !this.x) return;
      var out = open ? this.gift : this.x;
      var inn = open ? this.x : this.gift;
      var deg = open ? -90 : 90; /* gift exits to -90 / X enters from -90; X exits to +90 / gift enters from +90 */
      var r = reduced();
      var token = {};
      this._token = token;
      [this.gift, this.x].forEach(function (el) { if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); }); });
      out.hidden = false;
      inn.hidden = true;
      function kf(o1, d1, o2, d2) {
        return r ? [{ opacity: o1 }, { opacity: o2 }]
          : [{ opacity: o1, transform: 'rotate(' + d1 + 'deg)' }, { opacity: o2, transform: 'rotate(' + d2 + 'deg)' }];
      }
      var self = this;
      animateEl(out, kf(1, 0, 0, deg), { duration: 150, easing: EASE_INOUT, fill: 'forwards' }).then(function (a) {
        if (self._token !== token) return;
        out.hidden = true;
        if (a) a.cancel();
        inn.hidden = false;
        animateEl(inn, kf(0, deg, 1, 0), { duration: 150, easing: EASE_INOUT });
      });
    }
  }
  define('sk-rewards', SkRewards);

  /* ------------------------------------------------------------------
     Delegated / global listeners (bound once)
     ------------------------------------------------------------------ */
  if (window.__skChromeBound) return;
  window.__skChromeBound = true;

  /* hamburger → drawer */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sk-drawer-open]');
    if (!t) return;
    e.preventDefault();
    var id = t.getAttribute('aria-controls');
    var d = (id && document.getElementById(id)) || document.querySelector('sk-mobile-drawer');
    if (d && typeof d.open === 'function') d.open(t);
  });

  /* header cart badge: FE shows "99+" above 99 (Empire's own listener sets the number) */
  window.addEventListener('cartcount:update', function (e) {
    var n = e && e.detail ? Number(e.detail.item_count) : 0;
    Array.prototype.forEach.call(document.querySelectorAll('[data-header-cart-count]'), function (el) {
      el.classList.toggle('sk-hdr__count--max', n > 99);
    });
  });

  /* theme editor: selected announcement message stays visible */
  document.addEventListener('shopify:block:select', function (e) {
    var ann = e.target.closest && e.target.closest('sk-announcement');
    if (!ann || !ann.msgs) return;
    var msg = e.target.closest('[data-sk-ann-msg]');
    ann.pause();
    if (msg) ann.show(ann.msgs.indexOf(msg), true);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var ann = e.target.closest && e.target.closest('sk-announcement');
    if (ann && ann.resume) ann.resume();
  });
  document.addEventListener('shopify:section:select', function (e) {
    var ann = e.target.querySelector && e.target.querySelector('sk-announcement');
    if (ann && ann.pause) ann.pause();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var ann = e.target.querySelector && e.target.querySelector('sk-announcement');
    if (ann && ann.resume) ann.resume();
  });

  /* Search lists products only, like staging: the search forms send type=product, so the results
     page (sections/sk-search) opens once instead of replacing itself with that URL. Empire's live
     search submits a copy of its form, hidden field included. */
  /* ---------- Phone search sheet (SK-56) ----------
     The header's magnifier ([data-mobile-search-button], under 640px) is meant to open Empire's
     "takeover" search, which never shows in this header: the tap did nothing. It now opens our own
     sheet at the top of the screen: the search pill, Go, Cancel; the search goes to the products
     search page (type=product) like the desktop pill. */
  var SEARCH_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>';
  var searchSheet = null;
  function ensureSearchSheet() {
    if (searchSheet) return searchSheet;
    var routes = (window.skTheme && window.skTheme.routes) || (window.Theme && window.Theme.routes) || {};
    var d = document.createElement('dialog');
    d.className = 'sk-ssheet';
    d.setAttribute('aria-label', 'Search');
    d.innerHTML =
      '<form class="sk-ssheet__form" action="' + (routes.search_url || '/search') + '" method="get" role="search">' +
        '<input type="hidden" name="type" value="product">' +
        '<label class="sk-ssheet__field">' + SEARCH_ICON +
          '<input class="sk-ssheet__input" type="search" name="q" placeholder="What are you looking for?" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="search" aria-label="Search">' +
        '</label>' +
        '<button type="submit" class="sk-ssheet__go" aria-label="Search">' + SEARCH_ICON + '</button>' +
        '<button type="button" class="sk-ssheet__cancel" data-sk-ssheet-close>Cancel</button>' +
      '</form>';
    document.body.appendChild(d);
    d.addEventListener('click', function (e) {
      if (e.target === d || (e.target.closest && e.target.closest('[data-sk-ssheet-close]'))) d.close();
    });
    d.addEventListener('submit', function (e) {
      var q = d.querySelector('input[name="q"]');
      if (!q.value.trim()) { e.preventDefault(); q.focus(); }
    });
    searchSheet = d;
    typePlaceholder(d.querySelector('.sk-ssheet__input'));
    return d;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mobile-search-button]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var d = ensureSearchSheet();
    if (!d.open) d.showModal();
    var q = d.querySelector('input[name="q"]');
    q.value = '';
    q.focus();
  }, true);

  function productSearch(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('form[action$="/search"]').forEach(function (form) {
      if (form.querySelector('[name="type"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'type';
      input.value = 'product';
      form.appendChild(input);
    });
  }
  productSearch(document);
  document.addEventListener('shopify:section:load', function (e) { productSearch(e.target); });

  /* Search bars type their placeholder, "What are you looking for?", letter by letter, hold it,
     erase it and start again. They stop while the field is focused or filled; with reduced
     motion the phrase simply shows. The field keeps its aria-label for screen readers. */
  var TYPE_TEXT = 'What are you looking for?';
  var typeReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function typePlaceholder(input) {
    if (!input || input.__skTyping) return;
    input.__skTyping = true;
    if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Search products, brands, categories');
    if (typeReduced) { input.placeholder = TYPE_TEXT; return; }
    var i = 0, dir = 1, timer = null;
    function idle() { return document.activeElement !== input && !input.value; }
    function tick() {
      if (!idle()) { input.placeholder = TYPE_TEXT; timer = setTimeout(tick, 600); return; }
      i += dir;
      input.placeholder = TYPE_TEXT.slice(0, i) + (dir > 0 && i < TYPE_TEXT.length ? '|' : '');
      var wait = dir > 0 ? 75 + Math.random() * 60 : 32;
      if (dir > 0 && i >= TYPE_TEXT.length) { dir = -1; wait = 2400; }
      else if (dir < 0 && i <= 0) { dir = 1; wait = 650; }
      timer = setTimeout(tick, wait);
    }
    input.placeholder = '';
    timer = setTimeout(tick, 700);
  }
  function typeAll(root) {
    (root || document).querySelectorAll('[data-live-search-input], .sk-ssheet__input').forEach(typePlaceholder);
  }
  typeAll(document);
  document.addEventListener('shopify:section:load', function (e) { typeAll(e.target); });
})();
} catch (skBundleError) {
  if (window.console) console.error('[sk-bundle] sk-chrome.js', skBundleError);
}

/* ===== sk-cart.js ===== */
try {
/* SawaKart cart sidebar = staging's CartDrawer on Shopify's cart (theme only).

   - A native <dialog> (showModal: top layer, inert page, Esc), added to <body> on first use. Its
     content is sections/sk-cart-drawer.liquid, fetched with the Section Rendering API or returned
     by /cart/change.js in its "sections" field.
   - Opens from the header cart icon, from SK.cartDrawer.open() (sk-core.js home cards) and after
     Empire's own add-to-cart (listing cards, quick shop, product page): Empire adds the product and
     inserts its flyout, then fires cartcount:update. The flyout is kept invisible (sk-cart.css) and,
     once its opening has finished (which is when Empire traps focus in it), Empire is asked to close
     it with closeFlyouts, so Empire removes the flyout and its focus trap itself.
   - Quantity: the number changes at once; the clicks of the last 350ms (on any line) are merged into one
     /cart/update.js call, the buttons stay usable while it runs, and only the final answer is drawn
     (SK-56: before, every click was a 650ms round trip with the buttons disabled). Remove goes at once.
     Clear goes through /cart/clear.js. Checkout waits for a pending change. cartcount:update keeps
     Empire's header badge in step. If this file does not load, Empire's flyout simply stays. */
(function () {
  'use strict';
  window.SK = window.SK || {};
  if (window.SK.cartDrawer) return;

  var SECTION = 'sk-cart-drawer';
  var html = document.documentElement;
  var dialog = null;
  var content = null;
  /* SK-69: what the cart logic works on: the sidebar <dialog>, or on /cart the page's cart
     (sections/sk-cart-page.liquid, redrawn from its own section id) */
  var root = null;
  var section = SECTION;
  var pageMode = false;
  var trigger = null;
  var busy = false;
  var loaded = false;
  var lastAtc = null;
  var requestId = 0;
  var pending = {};          /* line key -> wanted quantity, not sent yet */
  var inflight = null;       /* the running update */
  var flushTimer = 0;
  var checkoutWanted = false;
  var MAX_QTY = 999;
  var DEBOUNCE = 350;

  var CLOSE_ICON = '<svg class="sk-icon sk-cart__close-ico" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  function routes() {
    var t = (window.Theme && window.Theme.routes) || {};
    var s = (window.skTheme && window.skTheme.routes) || {};
    return {
      cart: t.cart_url || s.cart_url || '/cart',
      change: t.cart_change_url || s.cart_change_url || '/cart/change',
      update: t.cart_update_url || s.cart_update_url || '/cart/update',
      clear: t.cart_clear_url || '/cart/clear'
    };
  }

  function onCartPage() { return document.body && document.body.classList.contains('template-cart'); }

  function reduced() {
    if (window.SK && typeof window.SK.reducedMotion === 'function') return !!window.SK.reducedMotion();
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isModified(e) {
    return e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
  }

  /* ---------- the dialog ---------- */

  function ensure() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'sk-cart';
    dialog.setAttribute('aria-labelledby', 'sk-cart-title');
    dialog.innerHTML = '<div class="sk-cart__content" data-sk-cart-content>' + shell() + '</div>';
    document.body.appendChild(dialog);
    content = dialog.querySelector('[data-sk-cart-content]');
    root = dialog;

    dialog.addEventListener('click', onClick);
    dialog.addEventListener('submit', onSubmit);
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dialog.addEventListener('close', onClosed);
  }

  /* First open, before the cart arrives: staging's header and spinner. */
  function shell() {
    return '<div class="sk-cart__inner">' +
      '<div class="sk-cart__head"><h2 class="sk-cart__title" id="sk-cart-title">Cart</h2>' +
      '<button type="button" class="sk-cart__close" aria-label="Close cart" data-sk-cart-close>' + CLOSE_ICON + '</button></div>' +
      '<div class="sk-cart__loading"><span class="sk-cart__spinner" role="status" aria-label="Loading cart"></span></div>' +
      '</div>';
  }

  function open(options) {
    options = options || {};
    /* on the cart page the cart is already on screen: bring it up to date instead */
    if (pageMode) { if (options.html) render(options.html); else refresh(); return; }
    ensure();
    trigger = options.trigger || document.activeElement;
    if (!dialog.open) {
      dialog.classList.remove('is-closing');
      dialog.showModal();
      html.classList.add('sk-scroll-lock');
    } else {
      dialog.classList.remove('is-closing');
    }
    if (options.html) render(options.html);
    else refresh();
  }

  function close() {
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    if (reduced()) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      dialog.removeEventListener('transitionend', onEnd);
      if (dialog.classList.contains('is-closing')) dialog.close();
    };
    var onEnd = function (e) { if (e.target === dialog) finish(); };
    dialog.addEventListener('transitionend', onEnd);
    setTimeout(finish, 400);
  }

  function onClosed() {
    dialog.classList.remove('is-closing');
    html.classList.remove('sk-scroll-lock');
    var back = trigger;
    trigger = null;
    if (back && back.isConnected && typeof back.focus === 'function') {
      try { back.focus({ preventScroll: true }); } catch (e) { /* not focusable */ }
    }
  }

  /* ---------- content ---------- */

  function render(markup) {
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    var inner = doc.querySelector('[data-sk-cart-inner]');
    if (!inner || !content) return false;
    var scroller = content.querySelector('.sk-cart__body');
    var top = scroller ? scroller.scrollTop : 0;
    /* keep the keyboard on the same control (its aria-label is unique per line) */
    var active = document.activeElement;
    var hadFocus = !!(active && content.contains(active));
    var label = hadFocus ? active.getAttribute('aria-label') : null;
    var activeLine = hadFocus ? active.closest('[data-sk-cart-line]') : null;
    var nextLine = activeLine && activeLine.nextElementSibling ? activeLine.nextElementSibling.getAttribute('data-sk-cart-line') : null;
    content.replaceChildren(document.importNode(inner, true));
    loaded = true;
    var body = content.querySelector('.sk-cart__body');
    if (body && !pageMode) body.scrollTop = top;
    var refocus = pageMode ? hadFocus && !content.contains(document.activeElement) : (dialog.open && !dialog.contains(document.activeElement));
    if (refocus) {
      var back = null;
      if (label) back = content.querySelector('[aria-label="' + label.replace(/"/g, '\\"') + '"]');
      if (!back && nextLine) back = content.querySelector('[data-sk-cart-line="' + nextLine + '"] .sk-cart__step:not(:disabled)');
      if (!back) back = content.querySelector(pageMode ? '.sk-cart__step:not(:disabled), .sk-cart__empty-btn' : '[data-sk-cart-close]');
      if (back) back.focus({ preventScroll: true });
    }
    return true;
  }

  function refresh() {
    var id = ++requestId;
    if (loaded) setBusy(true);
    return fetch(routes().cart + '?section_id=' + encodeURIComponent(section), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (markup) { if (id === requestId) render(markup); })
      .catch(function () {
        if (id === requestId && !loaded) location.assign(routes().cart);
      })
      .then(function () { if (id === requestId) setBusy(false); });
  }

  function setBusy(on) {
    busy = on;
    if (!root) return;
    root.classList.toggle('is-busy', on);
    root.querySelectorAll('[data-sk-cart-qty], [data-sk-cart-clear]').forEach(function (btn) {
      if (on) {
        if (!btn.disabled) { btn.disabled = true; btn.setAttribute('data-sk-was-enabled', ''); }
      } else if (btn.hasAttribute('data-sk-was-enabled')) {
        btn.disabled = false;
        btn.removeAttribute('data-sk-was-enabled');
      }
    });
  }

  function showError(message) {
    var box = content && content.querySelector('[data-sk-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function cartUpdated(cart) {
    if (cart && typeof cart.item_count === 'number') {
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
    }
  }

  /* ---------- quantity: at once on screen, merged requests ---------- */

  function hasPending() { for (var k in pending) if (Object.prototype.hasOwnProperty.call(pending, k)) return true; return false; }

  /* The line as the visitor wants it, before the server answers. */
  function showLine(line, qty) {
    var num = line.querySelector('.sk-cart__num');
    var steps = line.querySelectorAll('.sk-cart__step');
    if (num) num.textContent = qty;
    if (steps[0]) { steps[0].setAttribute('data-sk-cart-qty', qty - 1); steps[0].disabled = qty <= 1; }
    if (steps[1]) { steps[1].setAttribute('data-sk-cart-qty', qty + 1); steps[1].disabled = qty >= MAX_QTY; }
    line.classList.add('is-pending');
    if (qty === 0) {
      line.classList.add('is-removing');
      line.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    }
    root.classList.add('is-busy');
    var box = content.querySelector('[data-sk-cart-error]');
    if (box) box.hidden = true;
  }

  function step(line, qty) {
    if (busy) return;
    qty = Math.max(0, Math.min(MAX_QTY, qty));
    var key = line.getAttribute('data-sk-cart-line');
    showLine(line, qty);
    pending[key] = qty;
    clearTimeout(flushTimer);
    if (qty === 0) flush();
    else flushTimer = setTimeout(flush, DEBOUNCE);
  }

  function flush() {
    clearTimeout(flushTimer);
    flushTimer = 0;
    if (inflight) return;                 /* sent when the running one answers */
    if (!hasPending()) { settle(); return; }
    var updates = pending;
    pending = {};
    var id = ++requestId;
    inflight = fetch(routes().update + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: [section], sections_url: routes().cart })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok || data.status) {
            var err = new Error('cart/update');
            err.skDescription = typeof data.description === 'string' ? data.description : '';
            throw err;
          }
          return data;
        });
      })
      .then(function (cart) {
        inflight = null;
        cartUpdated(cart);
        if (hasPending()) return flush();   /* newer clicks: send them, keep what is on screen */
        if (id !== requestId) return;
        var markup = cart.sections && cart.sections[section];
        if (!(markup && render(markup))) return refresh();
      })
      .catch(function (err) {
        inflight = null;
        pending = {};
        if (id !== requestId) return;
        return refresh().then(function () { showError((err && err.skDescription) || 'Failed to update'); });
      })
      .then(settle);
  }

  /* Nothing running and nothing waiting: the sidebar shows the real cart. */
  function settle() {
    if (inflight || hasPending()) return;
    root.classList.remove('is-busy');
    if (checkoutWanted) {
      checkoutWanted = false;
      var form = content.querySelector('[data-sk-cart-checkout]');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    }
  }

  function clearCart() {
    if (busy || inflight || hasPending()) return;
    var btn = content.querySelector('[data-sk-cart-clear]');
    if (btn) btn.textContent = 'Clearing...';
    setBusy(true);
    fetch(routes().clear + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) { cartUpdated(cart); return refresh(); })
      .catch(function () { refresh(); });
  }

  /* ---------- events inside the sidebar ---------- */

  function onClick(e) {
    /* A click on the backdrop lands on the dialog itself, outside its box. */
    if (dialog && e.target === dialog) {
      var r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { close(); return; }
    }
    var closer = e.target.closest('[data-sk-cart-close]');
    if (closer) { close(); return; }
    var qty = e.target.closest('[data-sk-cart-qty]');
    if (qty) {
      var line = qty.closest('[data-sk-cart-line]');
      if (line && !qty.disabled) step(line, parseInt(qty.getAttribute('data-sk-cart-qty'), 10) || 0);
      return;
    }
    if (e.target.closest('[data-sk-cart-clear]')) clearCart();
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-sk-cart-checkout]');
    if (!form) return;
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    /* a quantity still on its way: send it first, then go */
    if (inflight || hasPending() || flushTimer) {
      e.preventDefault();
      checkoutWanted = true;
      btn.setAttribute('data-sk-label', btn.textContent);
      btn.textContent = btn.getAttribute('data-busy-text') || btn.textContent;
      flush();
      return;
    }
    btn.setAttribute('data-sk-label', btn.textContent);
    btn.textContent = btn.getAttribute('data-busy-text') || btn.textContent;
    setTimeout(function () { btn.disabled = true; }, 0);
  }

  /* Back from checkout (bfcache): the button is usable again. */
  window.addEventListener('pageshow', function () {
    if (!root) return;
    root.querySelectorAll('[data-sk-cart-checkout] [type="submit"][data-sk-label]').forEach(function (btn) {
      btn.textContent = btn.getAttribute('data-sk-label');
      btn.removeAttribute('data-sk-label');
      btn.disabled = false;
    });
  });

  /* ---------- openers ---------- */

  /* Header cart icon (keeps its /cart link for new tabs, no JS and the cart page). */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a.site-header-cart--button');
    if (!link || isModified(e) || onCartPage()) return;
    e.preventDefault();
    open({ trigger: link });
  });

  /* Remember the button that started an Empire add, to return focus to it. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.productitem__addtocart_btn, [data-quick-buy], [data-product-atc]');
    if (btn) lastAtc = btn;
  }, true);

  /* Empire's add-to-cart: take over from its flyout. Its hidden template ([data-templates]) is
     cloned for every flyout, so it is never touched; the flyouts already taken over are tracked here
     rather than by an attribute a clone could carry. */
  var handled = new WeakSet();
  window.addEventListener('cartcount:update', function () {
    if (onCartPage()) return;
    var flyouts = Array.prototype.filter.call(
      document.querySelectorAll('.atc-banner--container:not([data-sk-atc-banner])'),
      function (el) { return !el.closest('[data-templates]') && !handled.has(el); }
    );
    if (!flyouts.length) return;
    flyouts.forEach(handOver);
    var back = lastAtc && lastAtc.isConnected ? lastAtc : null;
    lastAtc = null;
    open({ trigger: back });
  });

  function handOver(flyOut) {
    handled.add(flyOut);
    flyOut.setAttribute('data-sk-handed', '');
    var released = false;
    var observer = null;
    var timer = 0;
    var release = function () {
      if (released) return;
      released = true;
      if (observer) observer.disconnect();
      clearTimeout(timer);
      /* After Empire's own reactions to the finished opening (its focus trap) have run. */
      setTimeout(function () { document.dispatchEvent(new Event('closeFlyouts')); }, 0);
    };
    var settled = function () {
      return flyOut.getAttribute('data-animation-state') === 'open' && !flyOut.hasAttribute('data-animation');
    };
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function () { if (settled()) release(); });
      observer.observe(flyOut, { attributes: true, attributeFilter: ['data-animation', 'data-animation-state'] });
    }
    timer = setTimeout(release, 1500);
  }

  html.classList.add('sk-cart-on');

  /* SK-69: the cart page. The script is deferred, so the page's cart is already parsed. */
  (function initPage() {
    var page = document.querySelector('[data-sk-cart-page]');
    var pageRoot = page && page.querySelector('[data-sk-cart-root]');
    if (!pageRoot) return;
    pageMode = true;
    root = pageRoot;
    content = pageRoot.querySelector('[data-sk-cart-content]');
    section = page.getAttribute('data-section-id') || section;
    loaded = true;
    pageRoot.addEventListener('click', onClick);
    pageRoot.addEventListener('submit', onSubmit);
  })();

  window.SK.cartDrawer = {
    open: open,
    close: close,
    refresh: refresh
  };
})();
} catch (skBundleError) {
  if (window.console) console.error('[sk-bundle] sk-cart.js', skBundleError);
}

/* ===== sk-quick-add.js ===== */
try {
/* SawaKart Quick add (theme only), loaded on every page (snippets/sk-head.liquid).

   The cards' Add button for a product with several variants opens this sheet instead of Empire's
   Quick Shop (whose gallery was hidden and broken): the photo of the chosen variant, photo tiles for
   one option (the colour, or the first option whose values have their own photos), pills for the
   others, price, quantity, "Add to Cart — $total" and "View full details". A centred dialog on
   computers, a bottom sheet on phones (styles: assets/sk-quick-add.css).
   - Triggers: [data-sk-quick-add="<handle>"] (home cards, snippets/sk-product-card.liquid) and
     SK.quickAdd.open(handle, { trigger }) (Empire cards, snippets/custom-footer-js.liquid).
   - Data: the public /products/<handle>.js. Adding: SK.cart.add (sk-core.js), which opens the cart
     sidebar; errors show inside the sheet. If the product can't be loaded, the product page opens.
   - SK.radioKeys(group, onPick) is shared with assets/sk-product.js (arrow keys in a radio group). */
(function () {
  'use strict';
  var SK = window.SK = window.SK || {};
  if (SK.quickAdd) return;

  var html = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var MAX_QTY = 999;
  var cache = {};

  var ICON_X = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
  var ICON_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>';
  var ICON_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/><path d="M12 5v14"/></svg>';
  var ICON_SEARCH = '<svg class="skv-search__ico" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>';

  /* ---------- helpers ---------- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var text = SK.formatMoney ? SK.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
    return String(text).replace(/^\$\s+/, '$');
  }

  // Shopify CDN image at a given width.
  function sized(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function rootUrl() {
    var r = (window.skTheme && skTheme.routes && skTheme.routes.root_url) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  /* Arrow keys / Home / End move between the radios of a group and pick them (roving tabindex). */
  SK.radioKeys = function (group, onPick) {
    group.addEventListener('keydown', function (e) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: 0, End: 0 };
      if (!(e.key in keys)) return;
      var radios = Array.prototype.filter.call(group.querySelectorAll('[role="radio"]'), function (r) { return !r.hidden; });
      var i = radios.indexOf(document.activeElement);
      if (i === -1 || !radios.length) return;
      e.preventDefault();
      var n = e.key === 'Home' ? 0 : e.key === 'End' ? radios.length - 1 : (i + keys[e.key] + radios.length) % radios.length;
      radios[n].focus();
      onPick(radios[n]);
    });
  };

  /* Keep one tab stop per radio group: the checked radio (or the first one). */
  SK.radioTabStops = function (group) {
    var radios = group.querySelectorAll('[role="radio"]');
    var checked = group.querySelector('[role="radio"][aria-checked="true"]:not([hidden])');
    each(radios, function (r) { r.tabIndex = -1; });
    var first = checked || Array.prototype.filter.call(radios, function (r) { return !r.hidden; })[0];
    if (first) first.tabIndex = 0;
  };

  /* ---------- product model ---------- */

  function Model(p) {
    this.p = p;
    this.variants = p.variants || [];
    this.optionNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    this.media = (p.media || []).filter(function (m) { return m && (m.preview_image || m.src); }).map(function (m) {
      return { id: String(m.id), src: (m.preview_image && m.preview_image.src) || m.src };
    });
    if (!this.media.length) {
      this.media = (p.images || []).map(function (src, i) { return { id: 'img' + i, src: src }; });
    }
    this.current = this.variants.filter(function (v) { return v.available; })[0] || this.variants[0];
    this.selected = this.current ? this.current.options.slice() : [];
  }

  Model.prototype.valuesOf = function (i) {
    var seen = {};
    var out = [];
    this.variants.forEach(function (v) {
      var val = v.options[i];
      if (val != null && !seen[val]) { seen[val] = true; out.push(val); }
    });
    return out;
  };

  Model.prototype.exact = function (opts) {
    return this.variants.filter(function (v) {
      for (var i = 0; i < opts.length; i++) if (v.options[i] !== opts[i]) return false;
      return true;
    })[0] || null;
  };

  // The variant with `value` at option `index` that keeps most of the other chosen options.
  Model.prototype.closest = function (index, value) {
    var self = this;
    var best = null;
    var bestScore = -1;
    this.variants.forEach(function (v) {
      if (v.options[index] !== value) return;
      var score = 0;
      v.options.forEach(function (o, i) { if (o === self.selected[i]) score += 2; });
      if (v.available) score += 1;
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  };

  // The primary option (the colour, else the first option with a choice): only crossed out when sold out in every
  // other option. Same rule as sections/sk-product.liquid.
  Model.prototype.primaryOption = function () {
    var p = this.photoOption();
    for (var i = 0; p === -1 && i < this.optionNames.length; i++) if (this.valuesOf(i).length > 1) p = i;
    return p === -1 ? 0 : p;
  };

  Model.prototype.variantFor = function (index, value) {
    var opts = this.selected.slice();
    opts[index] = value;
    return this.exact(opts) || this.closest(index, value);
  };

  Model.prototype.imageOf = function (v) {
    if (!v) return null;
    if (v.featured_media && v.featured_media.preview_image) return v.featured_media.preview_image.src;
    return v.featured_image ? v.featured_image.src : null;
  };

  Model.prototype.mediaIndexOf = function (v) {
    if (!v || !v.featured_media) return -1;
    var id = String(v.featured_media.id);
    for (var i = 0; i < this.media.length; i++) if (this.media[i].id === id) return i;
    return -1;
  };

  // Only one option gets photo tiles: the colour when its values show at least two different photos,
  // else the first such option (sizes stay pills even when each size has its own photo).
  Model.prototype.photoOption = function () {
    if (this._photoOption !== undefined) return this._photoOption;
    var self = this;
    var first = -1;
    var colour = -1;
    this.optionNames.forEach(function (name, i) {
      if (self.valuesOf(i).length < 2 || !self.hasPhotos(i)) return;
      if (first === -1) first = i;
      if (colour === -1 && /colou?r/i.test(name)) colour = i;
    });
    this._photoOption = colour !== -1 ? colour : first;
    return this._photoOption;
  };

  // True when the values of option i show at least two different photos.
  Model.prototype.hasPhotos = function (i) {
    var self = this;
    var srcs = {};
    var count = 0;
    this.valuesOf(i).forEach(function (val) {
      var v = self.variants.filter(function (x) { return x.options[i] === val && self.imageOf(x); })[0];
      var src = self.imageOf(v);
      if (src && !srcs[src]) { srcs[src] = true; count += 1; }
    });
    return count >= 2;
  };

  /* ---------- sheet ---------- */

  var dialog = null;
  var state = null; // { model, qty, index, trigger, busy, root }

  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'skq';
    dialog.setAttribute('aria-labelledby', 'skq-title');
    dialog.innerHTML =
      '<div class="skq__panel" tabindex="-1">' +
      '<span class="skq__grab" aria-hidden="true"></span>' +
      '<button type="button" class="skq__close" data-skq-close aria-label="Close">' + ICON_X + '</button>' +
      '<div class="skq__body" data-skq-body style="display:contents"></div>' +
      '</div>';
    document.body.appendChild(dialog);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || (e.target.closest && e.target.closest('[data-skq-close]'))) close();
    });
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });
    dialog.addEventListener('close', function () {
      html.classList.remove('skq-lock');
      dialog.classList.remove('is-closing');
      var back = state && state.trigger;
      state = null;
      if (back && back.isConnected && typeof back.focus === 'function') {
        try { back.focus({ preventScroll: true }); } catch (err) { /* not focusable */ }
      }
    });
  }

  function body() { return dialog.querySelector('[data-skq-body]'); }

  function showLoading() {
    body().innerHTML = '<div class="skq__scroll"><div class="skq__loading" role="status"><span class="skq__spin"></span>Loading options…</div></div>';
  }

  function close(keepFocus) {
    if (!dialog || !dialog.open) return;
    if (keepFocus && state) state.trigger = null;
    if (reduced) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    setTimeout(function () { if (dialog.open) dialog.close(); }, 200);
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (p) {
      cache[handle] = p;
      return p;
    });
  }

  function open(handle, opts) {
    opts = opts || {};
    if (!handle) return;
    ensureDialog();
    var token = {};
    state = { token: token, trigger: opts.trigger || document.activeElement, qty: 1, index: 0, busy: false };
    showLoading();
    dialog.classList.remove('is-closing');
    if (!dialog.open) dialog.showModal();
    html.classList.add('skq-lock');
    // Start on the sheet itself (no focus ring on a control); Tab reaches the options and Add.
    dialog.querySelector('.skq__panel').focus({ preventScroll: true });
    load(handle).then(function (p) {
      if (!state || state.token !== token) return;
      render(new Model(p));
    }).catch(function () {
      if (!state || state.token !== token) return;
      window.location.assign(rootUrl() + 'products/' + encodeURIComponent(handle));
    });
  }

  function optionMarkup(model, i) {
    var name = model.optionNames[i] || 'Option';
    var photos = model.photoOption() === i;
    var values = model.valuesOf(i);
    if (!photos && SK.sortOptionValues) values = SK.sortOptionValues(values); // sizes in order (sk-head.liquid)
    var many = values.length > 12;
    var out = '<div class="skv-option" data-skq-option="' + i + '">' +
      '<p class="skv-option__head"><span class="skv-option__name">' + esc(name) + ':</span> ' +
      '<span class="skv-option__value" data-skq-value>' + esc(model.selected[i]) + '</span></p>';
    if (many) {
      out += '<div class="skv-search">' + ICON_SEARCH +
        '<input type="text" class="skv-search__input" data-skq-search placeholder="Search ' + esc(name.toLowerCase()) + '…" aria-label="Search ' + esc(name.toLowerCase()) + '" autocomplete="off"></div>' +
        '<p class="skv-empty" data-skq-empty hidden>No matches</p>';
    }
    out += '<div class="' + (photos ? 'skv-tiles' : 'skv-pills') + (many ? (photos ? ' skv-tiles--scroll' : ' skv-pills--scroll') : '') +
      '" role="radiogroup" aria-label="' + esc(name) + '">';
    values.forEach(function (val) {
      if (photos) {
        out += '<button type="button" class="skv-tile" role="radio" aria-checked="false" data-value="' + esc(val) + '" aria-label="' + esc(val) + '">' +
          '<span class="skv-tile__check">' + ICON_CHECK + '</span>' +
          '<span class="skv-tile__img"><img alt="" loading="lazy" width="96" height="96" data-skq-tile-img>' +
          '<span class="skv-tile__oos">Sold out</span></span>' +
          '<span class="skv-tile__name">' + esc(val).replace(/\//g, '/<wbr>') + '</span></button>';
      } else {
        out += '<button type="button" class="skv-pill" role="radio" aria-checked="false" data-value="' + esc(val) + '">' + esc(val) + '</button>';
      }
    });
    return out + '</div></div>';
  }

  function render(model) {
    var p = model.p;
    var multi = [];
    model.optionNames.forEach(function (n, i) { if (model.valuesOf(i).length > 1) multi.push(i); });
    // The colour (photo) option is the primary choice: shown first, like the product page.
    var primary = model.primaryOption();
    if (multi.indexOf(primary) > 0) multi = [primary].concat(multi.filter(function (i) { return i !== primary; }));
    var url = p.url || (rootUrl() + 'products/' + p.handle);
    var thumbs = '';
    if (model.media.length > 1) {
      // One Tab stop for the strip; arrow keys move between photos (SK.radioKeys).
      thumbs = '<div class="skq__thumbs" role="radiogroup" aria-label="Photos">' + model.media.map(function (m, i) {
        return '<button type="button" class="skq__thumb" role="radio" aria-checked="false" tabindex="-1" data-skq-thumb="' + i + '" aria-label="Photo ' + (i + 1) + ' of ' + model.media.length + '">' +
          '<img src="' + esc(sized(m.src, 120)) + '" alt="" loading="lazy" width="52" height="52"></button>';
      }).join('') + '</div>';
    }
    body().innerHTML =
      '<div class="skq__scroll"><div class="skq__grid">' +
        '<div class="skq__media">' +
          '<div class="skq__photo"><img data-skq-photo alt="' + esc(p.title) + '" width="600" height="600"></div>' + thumbs +
        '</div>' +
        '<div class="skq__info">' +
          (p.vendor ? '<p class="skq__brand">' + esc(p.vendor) + '</p>' : '') +
          '<h2 class="skq__title" id="skq-title"><a href="' + esc(url) + '" data-skq-link>' + esc(p.title) + '</a></h2>' +
          '<div class="skq__price"><span class="skq__now" data-skq-price></span><span class="skq__was" data-skq-was hidden></span><span class="skq__save" data-skq-save hidden></span></div>' +
          '<p class="skq__stock" data-skq-stock hidden>Sold out</p>' +
          (multi.length ? '<hr class="skq__rule">' + multi.map(function (i) { return optionMarkup(model, i); }).join('') : '') +
          '<p class="skq__error" data-skq-error role="alert" hidden></p>' +
        '</div>' +
      '</div></div>' +
      '<div class="skq__footer">' +
        '<div class="skq-qty"><button type="button" class="skq-qty__btn" data-skq-minus aria-label="Decrease quantity">' + ICON_MINUS + '</button>' +
        '<span class="skq-qty__value" data-skq-qty aria-live="polite">1</span>' +
        '<button type="button" class="skq-qty__btn" data-skq-plus aria-label="Increase quantity">' + ICON_PLUS + '</button></div>' +
        '<button type="button" class="skq__atc" data-skq-atc><span data-skq-atc-label>Add to Cart</span></button>' +
        '<a class="skq__details" href="' + esc(url) + '" data-skq-details>View full details →</a>' +
      '</div>';
    state.model = model;
    state.root = body();
    state.index = Math.max(0, model.mediaIndexOf(model.current));
    bind();
    update({ photo: true });
    thumbsFade();
  }

  // Phones: the thumbnails scroll sideways; fade the right edge while more are hidden there.
  function thumbsFade() {
    var strip = state && state.root.querySelector('.skq__thumbs');
    if (!strip) return;
    strip.classList.toggle('has-more', strip.scrollLeft + strip.clientWidth < strip.scrollWidth - 2);
  }

  function choose(index, value) {
    var model = state.model;
    var v = model.variantFor(index, value);
    if (!v) return;
    model.current = v;
    model.selected = v.options.slice();
    hideError();
    update({ photo: true });
  }

  function showPhoto(i, fromVariant) {
    var model = state.model;
    if (!model.media.length) return;
    i = ((i % model.media.length) + model.media.length) % model.media.length;
    state.index = i;
    setPhoto(model.media[i].src);
    var strip = state.root.querySelector('.skq__thumbs');
    each(state.root.querySelectorAll('[data-skq-thumb]'), function (t) {
      var on = parseInt(t.getAttribute('data-skq-thumb'), 10) === i;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) {
        // keep the active thumbnail in view inside the strip (without scrolling the page)
        if (strip && strip.scrollWidth > strip.clientWidth) {
          var left = t.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft) strip.scrollLeft = left;
          else if (left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + t.offsetWidth - strip.clientWidth;
        }
      }
    });
    if (strip) SK.radioTabStops(strip);
    if (!fromVariant) {
      // A photo of a variant picks that variant (keeping the other options when possible).
      var id = model.media[i].id;
      var best = null;
      var bestScore = -1;
      model.variants.forEach(function (v) {
        if (!v.featured_media || String(v.featured_media.id) !== id) return;
        var score = 0;
        v.options.forEach(function (o, n) { if (o === model.selected[n]) score += 2; });
        if (v.available) score += 1;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      if (best && best !== model.current) {
        model.current = best;
        model.selected = best.options.slice();
        update({ photo: false });
      }
    }
  }

  function setPhoto(src) {
    var img = state.root.querySelector('[data-skq-photo]');
    if (!img || !src) return;
    var next = sized(src, 800);
    if (img.getAttribute('src') === next) return;
    img.classList.add('is-loading');
    img.onload = img.onerror = function () { img.classList.remove('is-loading'); };
    img.setAttribute('src', next);
  }

  function update(opts) {
    var model = state.model;
    var v = model.current;
    var root = state.root;
    var sale = v.compare_at_price && v.compare_at_price > v.price;
    root.querySelector('[data-skq-price]').textContent = money(v.price);
    root.querySelector('[data-skq-price]').classList.toggle('is-sale', !!sale);
    var was = root.querySelector('[data-skq-was]');
    var save = root.querySelector('[data-skq-save]');
    was.hidden = !sale;
    save.hidden = !sale;
    if (sale) {
      was.textContent = money(v.compare_at_price);
      save.textContent = 'Save ' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + '%';
    }
    root.querySelector('[data-skq-stock]').hidden = v.available;

    each(root.querySelectorAll('[data-skq-option]'), function (box) {
      var i = parseInt(box.getAttribute('data-skq-option'), 10);
      box.querySelector('[data-skq-value]').textContent = model.selected[i];
      var group = box.querySelector('[role="radiogroup"]');
      each(group.querySelectorAll('[role="radio"]'), function (r) {
        var val = r.getAttribute('data-value');
        var on = val === model.selected[i];
        var ex;
        if (i === model.primaryOption()) {
          var withVal = model.variants.filter(function (x) { return x.options[i] === val; });
          ex = withVal.filter(function (x) { return x.available; })[0] || withVal[0] || null;
        } else {
          // Crossed out when this value does not exist with the chosen colour, or that exact variant is sold out.
          var opts = model.selected.slice();
          opts[i] = val;
          ex = model.exact(opts);
        }
        var cand = (i === model.primaryOption() ? null : ex) || model.variantFor(i, val);
        r.setAttribute('aria-checked', on ? 'true' : 'false');
        var oos = !(ex && ex.available);
        r.classList.toggle('is-oos', oos);
        r.setAttribute('aria-label', val + (!ex ? ' (not available with the selected options)' : oos ? ' (sold out)' : ''));
        var badge = r.querySelector('.skv-tile__oos');
        if (badge) badge.textContent = ex ? 'Sold out' : 'Not available';
        var img = r.querySelector('[data-skq-tile-img]');
        if (img) {
          var src = model.imageOf(cand) || model.imageOf(model.variants.filter(function (x) { return x.options[i] === val; })[0]);
          if (src && img.getAttribute('src') !== sized(src, 200)) img.setAttribute('src', sized(src, 200));
        }
      });
      SK.radioTabStops(group);
    });

    if (opts.photo) {
      var mi = model.mediaIndexOf(v);
      if (mi >= 0) showPhoto(mi, true);
      else if (!root.querySelector('[data-skq-photo]').getAttribute('src')) showPhoto(state.index, true);
    }

    var link = (model.p.url || (rootUrl() + 'products/' + model.p.handle)) + '?variant=' + v.id;
    root.querySelector('[data-skq-details]').setAttribute('href', link);
    root.querySelector('[data-skq-link]').setAttribute('href', link);
    renderAtc();
  }

  function renderAtc() {
    var v = state.model.current;
    var root = state.root;
    root.querySelector('[data-skq-qty]').textContent = state.qty;
    root.querySelector('[data-skq-minus]').disabled = !v.available || state.qty <= 1;
    root.querySelector('[data-skq-plus]').disabled = !v.available || state.qty >= MAX_QTY;
    if (state.busy) return;
    var atc = root.querySelector('[data-skq-atc]');
    atc.disabled = !v.available;
    atc.querySelector('[data-skq-atc-label]').textContent = v.available ? 'Add to Cart — ' + money(v.price * state.qty) : 'Sold out';
  }

  function showError(msg) {
    var box = state.root.querySelector('[data-skq-error]');
    box.textContent = msg;
    box.hidden = false;
  }

  function hideError() {
    var box = state && state.root && state.root.querySelector('[data-skq-error]');
    if (box) box.hidden = true;
  }

  function addToCart() {
    var v = state.model.current;
    if (state.busy || !v.available) return;
    var atc = state.root.querySelector('[data-skq-atc]');
    var token = state.token;
    if (!(SK.cart && typeof SK.cart.add === 'function')) {
      window.location.assign((state.model.p.url || '/') + '?variant=' + v.id);
      return;
    }
    state.busy = true;
    hideError();
    atc.disabled = true;
    atc.querySelector('[data-skq-atc-label]').innerHTML = '<span style="display:inline-flex;align-items:center;gap:.5rem"><span class="skq__spin"></span>Adding…</span>';
    SK.cart.add(v.id, state.qty, atc).then(function () {
      if (!state || state.token !== token) return;
      state.busy = false;
      close(true); // the cart sidebar is open on top and has the focus
    }, function (err) {
      if (!state || state.token !== token) return;
      state.busy = false;
      renderAtc();
      showError((err && err.skDescription) || "Couldn't add to cart. Please try again.");
    });
  }

  function bind() {
    var root = state.root;
    each(root.querySelectorAll('[data-skq-option]'), function (box) {
      var i = parseInt(box.getAttribute('data-skq-option'), 10);
      var group = box.querySelector('[role="radiogroup"]');
      group.addEventListener('click', function (e) {
        var r = e.target.closest('[role="radio"]');
        if (r) choose(i, r.getAttribute('data-value'));
      });
      SK.radioKeys(group, function (r) { choose(i, r.getAttribute('data-value')); });
      // Computers: hovering a photo tile previews its photo.
      if (canHover && group.classList.contains('skv-tiles')) {
        group.addEventListener('mouseover', function (e) {
          if (!state.moved) return; // not for a cursor that was already where the sheet opened
          var r = e.target.closest('[role="radio"]');
          if (!r) return;
          var src = state.model.imageOf(state.model.variantFor(i, r.getAttribute('data-value')));
          if (src) setPhoto(src);
        });
        group.addEventListener('mouseleave', function () {
          var m = state.model.media[state.index];
          if (m) setPhoto(m.src);
        });
      }
      var search = box.querySelector('[data-skq-search]');
      if (search) {
        search.addEventListener('input', function () {
          var q = search.value.trim().toLowerCase();
          var shown = 0;
          each(group.querySelectorAll('[role="radio"]'), function (r) {
            var hide = !!q && r.getAttribute('data-value').toLowerCase().indexOf(q) === -1;
            r.hidden = hide;
            if (!hide) shown += 1;
          });
          box.querySelector('[data-skq-empty]').hidden = shown > 0;
          SK.radioTabStops(group);
        });
      }
    });
    root.parentNode.addEventListener('mousemove', function () { if (state) state.moved = true; }, { once: true });
    var strip = root.querySelector('.skq__thumbs');
    if (strip) {
      strip.addEventListener('scroll', thumbsFade, { passive: true });
      SK.radioKeys(strip, function (t) { showPhoto(parseInt(t.getAttribute('data-skq-thumb'), 10), false); });
    }
    each(root.querySelectorAll('[data-skq-thumb]'), function (t) {
      t.addEventListener('click', function () { showPhoto(parseInt(t.getAttribute('data-skq-thumb'), 10), false); });
    });
    root.querySelector('[data-skq-minus]').addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); renderAtc(); });
    root.querySelector('[data-skq-plus]').addEventListener('click', function () { state.qty = Math.min(MAX_QTY, state.qty + 1); renderAtc(); });
    root.querySelector('[data-skq-atc]').addEventListener('click', addToCart);
  }

  /* ---------- triggers ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sk-quick-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn.getAttribute('data-sk-quick-add'), { trigger: btn });
  });

  window.addEventListener('resize', function () { if (state && state.model) thumbsFade(); });

  SK.quickAdd = { open: open, close: close };
})();
} catch (skBundleError) {
  if (window.console) console.error('[sk-bundle] sk-quick-add.js', skBundleError);
}
